(() => {
    const tn = 'ACC_CF_Product_21';
    const SIZE_OPTION_NAMES = ['size', 'taille', 'größe', 'grosse', 'talla'];
    const SESSION_STORAGE_KEY = `${tn}--bundle-builder`;
    const SIDEBAR_HEIGHT_VAR = `--${tn}-bundle-sidebar-height`;
    const HEADER_HEIGHT_VAR = `--${tn}-bundle-header-height`;
    const HEADER_SELECTOR = '[data-header-height]';
    const HEADER_BAR_SELECTORS = ['.theme__header .header__desktop', '.theme__header .header__mobile'];
    const SIZE_CHART_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512.002 512.002" data-inject-url="https://cdn.kiwisizing.com/icons/ruler1.min.svg?v=5-inject2" class="kiwi-svg kiwi-injectable" crossorigin="Anonymous"><path d="M509.502 104.908L407.097 2.502c-3.337-3.337-8.73-3.337-12.067 0L2.502 395.03c-3.337 3.337-3.337 8.73 0 12.067l102.405 102.405c1.596 1.604 3.772 2.5 6.033 2.5s4.43-.896 6.033-2.5L509.5 116.975c1.604-1.596 2.5-3.772 2.5-6.033s-.894-4.43-2.498-6.034zM110.94 491.402l-90.338-90.338 380.46-380.46L491.4 110.94 110.94 491.4zm298.7-414.605c-14.115 0-25.6 11.486-25.6 25.6s11.486 25.6 25.6 25.6 25.6-11.486 25.6-25.6-11.486-25.6-25.6-25.6zm0 34.135c-4.7 0-8.534-3.832-8.534-8.534s3.823-8.534 8.534-8.534 8.534 3.832 8.534 8.534-3.823 8.534-8.534 8.534z"></path><use xlink:href="#B--inject-7"></use><use xlink:href="#C--inject-7"></use><use xlink:href="#B--inject-7" x="-51.203" y="51.195"></use><use xlink:href="#C--inject-7" x="-51.203" y="51.187"></use><use xlink:href="#B--inject-7" x="-102.405" y="102.39"></use><use xlink:href="#C--inject-7" x="-102.405" y="102.383"></use><path d="M164.643 244.95l12.066-12.07 25.6 25.593-12.066 12.07z"></path><use xlink:href="#C--inject-7" x="-153.608" y="153.595"></use><use xlink:href="#B--inject-7" x="-204.81" y="204.796"></use><use xlink:href="#C--inject-7" x="-204.81" y="204.797"></use><use xlink:href="#B--inject-7" x="-255.993" y="256.01"></use><path d="M36.634 372.976l12.068-12.068 34.135 34.135L70.77 407.11z"></path><defs><path id="B--inject-7" d="M318.253 91.37l12.068-12.068 25.603 25.603-12.068 12.068z"></path><path id="C--inject-7" d="M292.648 116.973l12.068-12.068 34.135 34.135-12.068 12.068z"></path></defs></svg>`;
    const KIWI_TRIGGER_SELECTOR = '.ks-chart-modal-link, .ks-chart-container a, .ks-chart-container button';
    const CTA_CHECKOUT_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M7.5 5.625L11.875 10L7.5 14.375" stroke="#FAFAFA" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    const SEARCH_EMPTY_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
  <g clip-path="url(#clip0_4897_6977)">
    <path d="M31.2676 27.7324L22.9251 19.3899C24.2841 17.3428 25 14.9722 25 12.5C25 5.6075 19.3925 0 12.5 0C5.6075 0 0 5.6075 0 12.5C0 19.3925 5.6075 25 12.5 25C14.9722 25 17.3429 24.2841 19.3899 22.9251L21.6959 25.2311C21.6962 25.2314 21.6965 25.2317 21.6969 25.2321L27.7324 31.2676C28.2048 31.7399 28.8324 32 29.5 32C30.1676 32 30.7953 31.7399 31.2674 31.2677C31.7398 30.7957 32 30.1679 32 29.5C32 28.8321 31.7398 28.2043 31.2676 27.7324ZM19.096 21.6079L19.0959 21.6081C17.1667 23.0093 14.8859 23.75 12.5 23.75C6.29675 23.75 1.25 18.7033 1.25 12.5C1.25 6.29675 6.29675 1.25 12.5 1.25C18.7033 1.25 23.75 6.29675 23.75 12.5C23.75 14.8859 23.0093 17.1667 21.608 19.0959C20.9069 20.0618 20.0618 20.9069 19.096 21.6079ZM20.4072 22.1746C21.0541 21.6454 21.6454 21.0541 22.1746 20.4072L23.9478 22.1804C23.4085 22.8169 22.8169 23.4086 22.1804 23.9478L20.4072 22.1746ZM30.3837 30.3837C30.1474 30.6199 29.8336 30.75 29.5 30.75C29.1664 30.75 28.8526 30.6199 28.6163 30.3837L23.0666 24.834C23.6996 24.2908 24.2908 23.6996 24.8339 23.0667L30.3838 28.6166C30.6199 28.8524 30.75 29.1661 30.75 29.5C30.75 29.8339 30.6199 30.1476 30.3837 30.3837Z" fill="#9E9E9E"/>
    <path d="M12.5 2.5C6.98594 2.5 2.5 6.98594 2.5 12.5C2.5 18.0141 6.98594 22.5 12.5 22.5C18.0141 22.5 22.5 18.0141 22.5 12.5C22.5 6.98594 18.0141 2.5 12.5 2.5ZM12.5 21.25C7.67525 21.25 3.75 17.3247 3.75 12.5C3.75 7.67525 7.67525 3.75 12.5 3.75C17.3247 3.75 21.25 7.67525 21.25 12.5C21.25 17.3247 17.3247 21.25 12.5 21.25Z" fill="#9E9E9E"/>
    <path d="M17.8054 7.19444C16.3427 5.73108 14.4211 5 12.5001 5C10.5785 5 8.65687 5.73108 7.19412 7.19444C4.26863 10.12 4.26863 14.8803 7.19412 17.8059C10.1196 20.7314 14.8799 20.7314 17.8054 17.8059C20.7315 14.8803 20.7315 10.12 17.8054 7.19444ZM13.3909 16.4402C13.3906 16.9324 12.9915 17.3312 12.4994 17.3312H12.4988C12.0064 17.3309 11.6074 16.9314 11.6078 16.439L11.6083 15.6764C11.6086 15.1842 12.0077 14.7854 12.4998 14.7854H12.5004C12.9928 14.7857 13.3918 15.1852 13.3914 15.6776L13.3909 16.4402ZM13.485 13.1871C13.4281 13.2081 13.3914 13.2579 13.3914 13.3141C13.3914 13.8065 12.9922 14.2057 12.4998 14.2057C12.0075 14.2057 11.6083 13.8065 11.6083 13.3141C11.6083 12.5154 12.1145 11.7922 12.8679 11.5142C13.3153 11.3492 13.5937 10.9168 13.5607 10.4384C13.5251 9.92245 13.0931 9.4904 12.5772 9.45486C12.2773 9.43382 11.9921 9.53468 11.7743 9.73796C11.5563 9.94147 11.4362 10.2177 11.4362 10.5158C11.4362 11.0081 11.037 11.4073 10.5447 11.4073C10.0523 11.4073 9.65309 11.0081 9.65309 10.5158C9.65309 9.72958 9.98279 8.97103 10.5577 8.43437C11.1322 7.89812 11.9134 7.62233 12.6998 7.67589C14.1077 7.77295 15.2425 8.90785 15.3396 10.3157C15.4263 11.5716 14.6636 12.7524 13.485 13.1871Z" fill="#DADADA"/>
  </g>
  <defs>
    <clipPath id="clip0_4897_6977">
      <rect width="32" height="32" fill="white"/>
    </clipPath>
  </defs>
</svg>`;
    const CLEAR_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z" fill="#646464"/>
</svg>`;
    const CLOSE_ICON_SVG = CLEAR_ICON_SVG;

    const COMPLETED_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="9" viewBox="0 0 12 9" fill="none">
  <path d="M4.04167 8.875L0 4.85417L1.0625 3.77083L4.04167 6.75L10.8125 0L11.875 1.0625L4.04167 8.875Z" fill="white"/>
</svg>`;

    const SEARCH_INPUT_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M16.7556 18L11.1556 12.4C10.7111 12.7556 10.2 13.037 9.62222 13.2444C9.04444 13.4519 8.42963 13.5556 7.77778 13.5556C6.16296 13.5556 4.7963 12.9963 3.67778 11.8778C2.55926 10.7593 2 9.39259 2 7.77778C2 6.16296 2.55926 4.7963 3.67778 3.67778C4.7963 2.55926 6.16296 2 7.77778 2C9.39259 2 10.7593 2.55926 11.8778 3.67778C12.9963 4.7963 13.5556 6.16296 13.5556 7.77778C13.5556 8.42963 13.4519 9.04444 13.2444 9.62222C13.037 10.2 12.7556 10.7111 12.4 11.1556L18 16.7556L16.7556 18ZM7.77778 11.7778C8.88889 11.7778 9.83333 11.3889 10.6111 10.6111C11.3889 9.83333 11.7778 8.88889 11.7778 7.77778C11.7778 6.66667 11.3889 5.72222 10.6111 4.94444C9.83333 4.16667 8.88889 3.77778 7.77778 3.77778C6.66667 3.77778 5.72222 4.16667 4.94444 4.94444C4.16667 5.72222 3.77778 6.66667 3.77778 7.77778C3.77778 8.88889 4.16667 9.83333 4.94444 10.6111C5.72222 11.3889 6.66667 11.7778 7.77778 11.7778Z" fill="#646464"/>
</svg>`;

    function escapeHtml(str) {
        return String(str ?? '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    function debounce(fn, wait) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => fn(...args), wait);
        };
    }

    function highlightSearchText(text, query) {
        const value = String(text ?? '');
        if (!query) return escapeHtml(value);

        const re = new RegExp(query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi');
        let html = '';
        let lastIndex = 0;
        let match;

        while ((match = re.exec(value)) !== null) {
            html += escapeHtml(value.slice(lastIndex, match.index));
            html += `<strong class="${tn}-bundle-products__search-highlight">${escapeHtml(match[0])}</strong>`;
            lastIndex = match.index + match[0].length;
        }

        html += escapeHtml(value.slice(lastIndex));
        return html;
    }

    function normalizeSize(value) {
        return String(value || '')
            .trim()
            .toUpperCase()
            .replace(/\s+/g, '');
    }

    function parseConfig(el) {
        const node = el.querySelector('[data-bundle-config]');
        if (!node) return {};
        try {
            const config = JSON.parse(node.textContent);
            const labelsNode = el.querySelector('[data-bundle-product-labels]');
            if (labelsNode) {
                try {
                    config.productLabels = JSON.parse(labelsNode.textContent);
                } catch {
                    config.productLabels = {};
                }
            }
            return config;
        } catch {
            return {};
        }
    }

    async function digestCacheKey(string) {
        const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(string));
        return Array.from(new Uint8Array(buf))
            .map((b) => b.toString(16).padStart(2, '0'))
            .join('');
    }

    function parseStorefrontGid(gid) {
        return Number(String(gid || '').split('/').pop());
    }

    class Xlr8dCfProduct21 extends HTMLElement {
        constructor() {
            super();
            this.tn = tn;
            this._kiwiHostSeq = 0;
            this._kiwiHostId = this.nextKiwiHostId();
            this.config = {};
            this.step = 1;
            this.slots = [null, null];
            this.activeSlotIndex = 0;
            this.selectedProductId = null;
            this.selectedSize = null;
            this.selectedProductData = null;
            this.activePrimaryId = '';
            this.activeSubHandle = '';
            this.activeSubId = '';
            this.searchMode = false;
            this.searchGridActive = false;
            this.searchQuery = '';
            this.searchResults = null;
            this.browsingSnapshot = null;
            this._ignoreSearchBlurOnce = false;
            this._sizeDockThresholdHidden = false;
            this.catalog = new Map();
            this.filteredProducts = [];
            this.collectionCache = new Map();
            this.collectionLabels = new Map();
            this.loading = false;
            this._rootCatalogInitPromise = null;
            this._rootCatalogFullPromise = null;
            this._storefrontFailed = false;
            this._jerseysQueryCache = null;
            this._storefrontCollectionPromises = new Map();
            this._debouncedPaginationGridRefresh = null;
            this._kiwiLoadId = 0;
            this._kiwiSyncTimer = null;
            this._kiwiSyncProductId = null;
            this._kiwiLoadingProductId = null;
            this._kiwiChartCache = new Map();
            this._kiwiModalObserver = null;
            this._kiwiModalWasOpen = false;
            this._kiwiScrollReturnProductId = null;
            this._collectionLoadId = 0;
            this._searchNavCache = null;
            this._boundClick = this.onClick.bind(this);
            this._boundInput = debounce(this.onSearchInput.bind(this), 300);
            this._boundSearchFocus = this.onSearchFocus.bind(this);
            this._boundSearchBlur = this.onSearchBlur.bind(this);
            this._boundDocumentPointerDown = this.onDocumentPointerDown.bind(this);
            this._boundSidebarHeight = debounce(this.updateSidebarHeightVar.bind(this), 100);
            this._boundHeaderHeight = debounce(this.updateHeaderHeightVar.bind(this), 100);
            this._boundViewportState = this.handleViewportState.bind(this);
            this._boundResize = debounce(() => {
                this.updateSidebarHeightVar();
                this.updateHeaderHeightVar();
            }, 100);
            this._sidebarObserver = null;
            this._headerObserver = null;
        }

        connectedCallback() {
            if (this.dataset.initialized === 'true') return;
            this.dataset.initialized = 'true';
            this.config = parseConfig(this);
            this.activePrimaryId = this.config.defaultPrimaryId || this.config.navigation?.primary?.[0]?.id || '';
            this.initActiveSubHandle();
            this.buildCollectionLabels();
            this.renderShell();
            this.bindEvents();
            this.initKiwiModalTracking();
            this.restoreFromSessionStorage();
            this.renderAll();
            this.dataset.shellReady = 'true';
            this.loadSearchChips();
            this.loadCurrentCollection();
            this.initSidebarHeightTracking();
            this.initHeaderHeightTracking();
            window.addEventListener('resize', this._boundResize);
            window.addEventListener('scroll', this._boundViewportState, { passive: true });
            this.validateSessionSlots();
        }

        disconnectedCallback() {
            this.removeEventListener('click', this._boundClick);
            document.removeEventListener('mousedown', this._boundDocumentPointerDown);
            this.querySelector('[data-bundle-search-input]')?.removeEventListener('input', this._boundInput);
            this.querySelector('[data-bundle-search-input]')?.removeEventListener('focus', this._boundSearchFocus);
            this.querySelector('[data-bundle-search-input]')?.removeEventListener('blur', this._boundSearchBlur);
            window.removeEventListener('resize', this._boundResize);
            window.removeEventListener('scroll', this._boundViewportState);
            this._sidebarObserver?.disconnect();
            this._sidebarObserver = null;
            this._headerObserver?.disconnect();
            this._headerObserver = null;
            this._kiwiModalObserver?.disconnect();
            this._kiwiModalObserver = null;
            this.clearSidebarHeightVar();
            this.clearHeaderHeightVar();
        }

        initActiveSubHandle() {
            const subs = this.getSubcategories();
            if (subs?.length) {
                const first = subs[0];
                this.activeSubId = first.id || first.handle;
                this.activeSubHandle = first.handle;
                return;
            }
            this.activeSubId = '';
            this.activeSubHandle = this.getPrimaryItem()?.handle || '';
        }

        buildCollectionLabels() {
            const nav = this.config.navigation || {};
            (nav.primary || []).forEach((item) => {
                this.collectionLabels.set(item.handle, item.label);
                const subs = nav.subcategories?.[item.id] || [];
                subs.forEach((sub) => {
                    if (!sub?.handle) return;
                    if (!this.getSharedCollectionHandles().has(sub.handle)) {
                        this.collectionLabels.set(sub.handle, sub.label);
                    }
                });
            });
        }

        getSharedCollectionHandles() {
            if (!this._sharedCollectionHandles) {
                const handleCounts = new Map();
                const nav = this.config.navigation || {};

                Object.values(nav.subcategories || {}).forEach((subs) => {
                    (subs || []).forEach((sub) => {
                        if (!sub?.handle) return;
                        handleCounts.set(sub.handle, (handleCounts.get(sub.handle) || 0) + 1);
                    });
                });

                this._sharedCollectionHandles = new Set(
                    [...handleCounts.entries()].filter(([, count]) => count > 1).map(([handle]) => handle)
                );
            }
            return this._sharedCollectionHandles;
        }

        searchNameMatchesQuery(name, query) {
            const q = this.normalizeMetaValue(query);
            const normalized = this.normalizeMetaValue(name);
            if (!q || q.length < 2 || !normalized) return false;
            if (normalized === q || normalized.startsWith(q)) return true;
            return normalized.split(/[\s-]+/).some((word) => word.startsWith(q));
        }

        searchSubcategoryMatchesQuery(col, query) {
            const q = this.normalizeMetaValue(query);
            if (!q || q.length < 2) return false;

            const terms = [col.label, col.filterValue].filter(Boolean);
            return terms.some((term) => {
                const normalized = this.normalizeMetaValue(term);
                if (!normalized) return false;
                if (normalized === q) return true;
                if (normalized.includes(q)) return true;
                return normalized.split(/\s+/).some((word) => word === q || word.startsWith(q));
            });
        }

        getNavSubcategories(primaryId, options = {}) {
            return (this.config.navigation?.subcategories?.[primaryId] || []).filter((sub) => {
                if (!sub?.handle || sub.id === 'all' || sub.label === 'All') return false;
                if (options.metafieldOnly && !sub.filterBy) return false;
                if (options.collectionOnly && sub.filterBy) return false;
                return true;
            });
        }

        mapSubToSearchCol(primaryId, sub) {
            return {
                primaryId,
                id: sub.id || sub.handle,
                handle: sub.handle,
                label: sub.label,
                filterBy: sub.filterBy,
                filterValue: sub.filterValue,
            };
        }

        createSearchCollectionEntry(col, products, query) {
            const q = String(query || '').toLowerCase();
            const matching = products.filter((product) => this.productMatchesSearch(product, q));
            return {
                ...col,
                products,
                matchingProducts: matching,
                matchCount: matching.length || products.length,
                image: this.getProductImage(matching[0] || products[0]),
            };
        }

        matchesCollectionSearch(col, products, query) {
            if (col.filterBy) return this.searchSubcategoryMatchesQuery(col, query);
            if (this.searchSubcategoryMatchesQuery(col, query)) return true;
            const q = String(query || '').toLowerCase();
            return products.some((product) => this.productMatchesSearch(product, q));
        }

        get rootPath() {
            return this.config.rootPath || '/';
        }

        get copy() {
            return this.config.copy || {};
        }

        getFilledSlotCount() {
            return this.slots.filter(Boolean).length;
        }

        isBundleFull() {
            return this.getFilledSlotCount() >= 2;
        }

        clearPendingSelection() {
            this.selectedProductId = null;
            this.selectedSize = null;
            this.selectedProductData = null;
        }

        syncStepFromSlots() {
            const filled = this.slots.filter(Boolean).length;
            if (filled === 0) {
                this.step = 1;
                this.activeSlotIndex = 0;
            } else if (filled === 1) {
                this.step = 2;
                this.activeSlotIndex = 1;
            } else {
                this.step = 3;
                this.activeSlotIndex = 1;
            }
        }

        saveToSessionStorage() {
            try {
                sessionStorage.setItem(
                    SESSION_STORAGE_KEY,
                    JSON.stringify({
                        version: 1,
                        slots: this.slots,
                    })
                );
            } catch (err) {
                console.error(`[${tn}-bundle-products] session save`, err);
            }
        }

        restoreFromSessionStorage() {
            try {
                const raw = sessionStorage.getItem(SESSION_STORAGE_KEY);
                if (!raw) return;

                const data = JSON.parse(raw);
                if (!data || data.version !== 1 || !Array.isArray(data.slots)) return;

                this.slots = [data.slots[0] || null, data.slots[1] || null];
                this.syncStepFromSlots();

                this.slots.forEach((slot) => {
                    if (!slot?.handle) return;
                    this.catalog.set(slot.handle, {
                        id: slot.productId,
                        handle: slot.handle,
                        title: slot.title,
                    });
                });
            } catch (err) {
                console.error(`[${tn}-bundle-products] session restore`, err);
            }
        }

        clearSessionStorage() {
            try {
                sessionStorage.removeItem(SESSION_STORAGE_KEY);
            } catch (err) {
                console.error(`[${tn}-bundle-products] session clear`, err);
            }
        }

        async validateSessionSlots() {
            if (!this.slots.some(Boolean)) return;

            await this.ensureRootCatalog();

            const results = await Promise.all(
                this.slots.map(async (slot, i) => {
                    if (!slot?.handle || !slot.variantId) {
                        return { i, slot, changed: false };
                    }

                    const product = await this.resolveProductDetails(slot.handle);
                    const variant = (product?.variants || []).find((v) => v.id === slot.variantId);

                    if (!product || !variant?.available || !this.isBundleEligibleProduct(product)) {
                        return { i, slot: null, changed: true };
                    }

                    const refreshedImage = this.getProductImage(product);
                    const refreshedPrice = this.getVariantPriceCents(variant);
                    if (
                        slot.title !== product.title ||
                        slot.price !== refreshedPrice ||
                        (refreshedImage && slot.image !== refreshedImage)
                    ) {
                        return {
                            i,
                            slot: {
                                ...slot,
                                title: product.title,
                                cutline: this.getCutline(product),
                                image: refreshedImage || slot.image,
                                price: refreshedPrice,
                            },
                            changed: true,
                        };
                    }

                    return { i, slot, changed: false };
                })
            );

            if (!results.some((result) => result.changed)) return;

            const nextSlots = [...this.slots];
            results.forEach(({ i, slot, changed }) => {
                if (changed) nextSlots[i] = slot;
            });

            this.slots = nextSlots;
            if (nextSlots[0] === null && nextSlots[1]) {
                this.slots = [nextSlots[1], null];
            }
            this.syncStepFromSlots();

            if (!this.slots.some(Boolean)) {
                this.clearSessionStorage();
            } else {
                this.saveToSessionStorage();
            }
            this.renderAll();
        }

        normalizeToCents(price) {
            const n = Number(price);
            if (!Number.isFinite(n) || n <= 0) return 0;
            const raw = String(price).trim();
            if (raw.includes('.')) return Math.round(n * 100);
            return Math.round(n);
        }

        getVariantPriceCents(variant) {
            if (!variant) return 0;
            return this.normalizeToCents(variant.price);
        }

        getBundleDiscountCents(amountCents) {
            if (!amountCents) return 0;
            const percent = Number(this.config.discountPercent);
            return Math.round(amountCents * (percent / 100));
        }

        formatMoney(cents) {
            const amount = Number(cents || 0);
            const format = this.config.moneyWithCurrencyFormat || this.config.moneyFormat || '${{amount}}';
            if (typeof window.Shopify?.formatMoney === 'function') {
                return window.Shopify.formatMoney(amount, format);
            }
            const value = (amount / 100).toFixed(2);
            return format.replace(/\{\{\s*amount\s*\}\}/, value).replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(amount / 100)));
        }

        renderShell() {
            const c = this.copy;
            this.innerHTML = `
        <template data-close-icon>${CLOSE_ICON_SVG}</template>
        <div class="${tn}-bundle-products__layout" data-bundle-layout>
          <div class="${tn}-bundle-products__main">
            <header class="${tn}-bundle-products__header">
              <span class="${tn}-bundle-products__badge">${escapeHtml(c.badge)}</span>
              <h1 class="${tn}-bundle-products__heading">${escapeHtml(c.heading)}</h1>
              <p class="${tn}-bundle-products__subheading">${escapeHtml(c.subheading)}</p>
            </header>
            <div class="${tn}-bundle-products__progress" data-bundle-progress></div>
            <div class="${tn}-bundle-products__search-wrap" data-bundle-search-wrap>
              <div class="${tn}-bundle-products__search-field">
                <form class="${tn}-bundle-products__search" data-bundle-search-form>
                  <span class="${tn}-bundle-products__search-icon" aria-hidden="true">
                    ${SEARCH_INPUT_ICON_SVG}
                  </span>
                  <input type="search" class="${tn}-bundle-products__search-input" data-bundle-search-input placeholder="${escapeHtml(c.searchPlaceholder)}" autocomplete="off" />
                  <button type="button" class="${tn}-bundle-products__search-clear is-hidden" data-bundle-search-clear data-action="search-clear" aria-label="Clear search">
                    ${CLEAR_ICON_SVG}
                  </button>
                  <button type="button" class="${tn}-bundle-products__search-cancel is-hidden" data-bundle-search-cancel data-action="search-cancel">${escapeHtml(c.searchCancel)}</button>
                </form>
                <div class="${tn}-bundle-products__search-dropdown is-hidden" data-bundle-search-dropdown></div>
              </div>
            </div>
            <div class="${tn}-bundle-products__nav" data-bundle-nav></div>
            <div class="${tn}-bundle-products__grid-wrap">
              <div class="${tn}-bundle-products__grid" data-bundle-grid></div>
              <div class="${tn}-bundle-products__empty is-hidden" data-bundle-empty></div>
              <div class="${tn}-bundle-products__loading is-hidden" data-bundle-loading>Loading...</div>
              <div class="${tn}-bundle-products__size-dock is-disabled" data-bundle-size-dock>
                <div class="${tn}-bundle-products__size-dock-inner">
                  <div class="${tn}-bundle-products__size-head">
                    <p>${escapeHtml(c.sizeLabel)}</p>
                    <div class="${tn}-bundle-products__size-chart-host is-available" data-bundle-size-chart-host>
                      ${this.buildSizeChartPlaceholderHtml(c.sizeChart)}
                      <span class="${tn}-bundle-products__size-chart-loader" data-bundle-size-chart-loader aria-hidden="true"></span>
                      ${this.buildKiwiHostHtml()}
                    </div>
                  </div>
                  <div class="${tn}-bundle-products__size-panel" data-bundle-size-panel></div>
                  <div class="${tn}-bundle-products__add-wrap" data-bundle-add-wrap></div>
                </div>
              </div>
            </div>
          </div>
          <aside class="${tn}-bundle-products__sidebar" data-bundle-sidebar></aside>
        </div>
        <div class="${tn}-bundle-products__mobile-cta" data-bundle-mobile-cta></div>
      `;
            this.renderSizeChart(null);
        }

        bindEvents() {
            this.addEventListener('click', this._boundClick);
            document.addEventListener('mousedown', this._boundDocumentPointerDown);
            const searchInput = this.querySelector('[data-bundle-search-input]');
            searchInput?.addEventListener('input', this._boundInput);
            searchInput?.addEventListener('focus', this._boundSearchFocus);
            searchInput?.addEventListener('blur', this._boundSearchBlur);
            this.querySelector('[data-bundle-search-form]')?.addEventListener('submit', (e) => e.preventDefault());
            this.querySelector('[data-bundle-search-dropdown]')?.addEventListener('mousedown', (e) => e.preventDefault());
        }

        onClick(e) {
            const target = e.target;
            if (!target) return;

            const actionEl = target.closest('[data-action]');
            if (actionEl) {
                const action = actionEl.dataset.action;
                e.preventDefault();

                switch (action) {
                    case 'primary-tab':
                        this.setPrimaryTab(actionEl.dataset.primaryId);
                        break;
                    case 'sub-tab':
                        this.setSubTab(actionEl.dataset.subId || actionEl.dataset.handle);
                        break;
                    case 'select-product':
                        this.selectProduct(Number(actionEl.dataset.productId));
                        break;
                    case 'select-size':
                        this.selectSize(actionEl.dataset.size);
                        break;
                    case 'add-jersey':
                        this.addJersey();
                        break;
                    case 'remove-jersey':
                        this.removeJersey(Number(actionEl.dataset.slotIndex));
                        break;
                    case 'sidebar-cta':
                        this.handleSidebarCta();
                        break;
                    case 'search-clear':
                        this.clearSearchText();
                        break;
                    case 'search-cancel':
                        this.exitSearchMode();
                        break;
                    case 'search-chip':
                        this.applySearchChip(actionEl.dataset.chip);
                        break;
                    case 'search-select-product':
                        this.selectSearchProduct(Number(actionEl.dataset.productId));
                        break;
                    case 'search-select-collection':
                        this.selectSearchCollection(actionEl.dataset.primaryId, actionEl.dataset.subId);
                        break;
                    case 'search-select-club':
                        this.selectSearchClub(actionEl.dataset.club, actionEl.dataset.searchGroup);
                        break;
                    case 'search-select-player':
                        this.selectSearchPlayer(actionEl.dataset.player);
                        break;
                    case 'open-size-chart':
                        this.openSizeChart();
                        break;
                    default:
                        break;
                }
                return;
            }
        }

        onSearchFocus() {
            this.enterSearchMode();
        }

        onSearchBlur() {
            window.setTimeout(() => {
                if (this._ignoreSearchBlurOnce) {
                    this._ignoreSearchBlurOnce = false;
                    return;
                }
                if (this.querySelector('[data-bundle-search-input]') === document.activeElement) return;
                if (!this.searchQuery && this.searchMode) {
                    this.exitSearchMode();
                }
            }, 0);
        }

        onDocumentPointerDown(e) {
            if (!this.searchMode) return;
            const target = e.target;
            if (!(target instanceof Node)) return;

            const searchWrap = this.querySelector('[data-bundle-search-wrap]');
            const searchDropdown = this.querySelector('[data-bundle-search-dropdown]');
            if (searchWrap?.contains(target) || searchDropdown?.contains(target)) return;

            this.exitSearchMode();
        }

        onSearchInput(e) {
            this.searchQuery = e.target.value.trim();
            this.updateSearchControls();
            if (this.searchQuery) {
                this.enterSearchMode();
                this.applySearchFilter();
            } else if (this.searchMode && this.browsingSnapshot) {
                this.filteredProducts = [...this.browsingSnapshot.filteredProducts];
                this.renderGrid();
                this.renderNav();
                this.updateSearchControls();
            }
        }

        enterSearchMode() {
            if (this.searchMode) return;
            this.browsingSnapshot = {
                activePrimaryId: this.activePrimaryId,
                activeSubHandle: this.activeSubHandle,
                activeSubId: this.activeSubId,
                searchGridActive: this.searchGridActive,
                filteredProducts: [...this.filteredProducts],
            };
            this.searchMode = true;
            this.updateSearchControls();
        }

        exitSearchMode() {
            const hadQuery = !!this.searchQuery;
            this.searchMode = false;
            this.searchQuery = '';
            this.searchResults = null;
            this._searchNavCache = null;
            const input = this.querySelector('[data-bundle-search-input]');
            if (input) {
                input.value = '';
                if (document.activeElement === input) input.blur();
            }
            this.updateSearchControls();
            this.searchGridActive = false;

            if (!this.browsingSnapshot) return;

            this.searchGridActive = !!this.browsingSnapshot.searchGridActive;
            this.activePrimaryId = this.searchGridActive ? '' : this.browsingSnapshot.activePrimaryId;
            this.activeSubHandle = this.searchGridActive ? '' : this.browsingSnapshot.activeSubHandle;
            this.activeSubId = this.searchGridActive
                ? ''
                : this.browsingSnapshot.activeSubId || this.browsingSnapshot.activeSubHandle;

            if (hadQuery) {
                this.filteredProducts = [...this.browsingSnapshot.filteredProducts];
                this.renderGrid();
                this.renderNav();
            }

            this.browsingSnapshot = null;
        }

        async loadSearchChips() {
            const fallback = (this.config.searchChipsFallback || []).filter(
                (chip) => typeof chip === 'string' && chip.trim()
            );
            const url = this.config.searchChipsUrl;
            if (!url) {
                if (fallback.length) this.config.searchChips = fallback;
                return;
            }

            try {
                const res = await fetch(url, { cache: 'no-store' });
                if (!res.ok) throw new Error(`searchChips fetch failed: ${res.status}`);
                const chips = await res.json();
                const next = Array.isArray(chips)
                    ? chips.filter((chip) => typeof chip === 'string' && chip.trim())
                    : [];
                if (!next.length) throw new Error('searchChips empty');

                this.config.searchChips = next;
                if (this.searchMode) this.renderSearchDropdown();
            } catch (err) {
                console.error(`[${tn}] loadSearchChips`, err);
                if (fallback.length) {
                    this.config.searchChips = fallback;
                    if (this.searchMode) this.renderSearchDropdown();
                }
            }
        }

        buildSearchChipsHtml() {
            return (this.config.searchChips || []).reduce((html, chip) => {
                html += `<button type="button" class="${tn}-bundle-products__search-chip" data-action="search-chip" data-chip="${escapeHtml(chip)}">${escapeHtml(chip)}</button>`;
                return html;
            }, '');
        }

        clearSearchText() {
            this.searchQuery = '';
            const input = this.querySelector('[data-bundle-search-input]');
            if (input) {
                this._ignoreSearchBlurOnce = true;
                input.value = '';
                input.focus({ preventScroll: true });
            }
            this.updateSearchControls();
            this.applySearchFilter();
        }

        updateSearchControls() {
            const hasQuery = !!this.searchQuery;
            const hasResults = this.hasSearchResults();
            const noResults = hasQuery && !hasResults;
            const showDropdown = this.searchMode && (!hasQuery || noResults || hasResults);
            this.querySelector('[data-bundle-search-clear]')?.classList.toggle('is-hidden', !hasQuery);
            this.querySelector('[data-bundle-search-cancel]')?.classList.toggle('is-hidden', !this.searchMode);
            this.querySelector('[data-bundle-search-wrap]')?.classList.toggle('is-active', this.searchMode);
            const dropdown = this.querySelector('[data-bundle-search-dropdown]');
            dropdown?.classList.toggle('is-hidden', !showDropdown);
            dropdown?.classList.toggle('is-empty-results', noResults);
            dropdown?.classList.toggle('has-results', hasQuery && hasResults);
            if (showDropdown) this.renderSearchDropdown();
        }

        hasSearchResults() {
            if (!this.searchResults) return false;
            return Object.values(this.searchResults).some((items) => items.length);
        }

        getTeamSearchCollections() {
            return this.getNavSubcategories('teams', { collectionOnly: true }).map((sub) =>
                this.mapSubToSearchCol('teams', sub)
            );
        }

        getCountriesSearchSub() {
            const subsByPrimary = this.config.navigation?.subcategories || {};
            const entries = Object.entries(subsByPrimary);
            for (let i = 0; i < entries.length; i++) {
                const [primaryId, subs] = entries[i];
                const sub = (subs || []).find((item) => item.id === 'countries');
                if (sub) return this.mapSubToSearchCol(primaryId, sub);
            }
            return null;
        }

        getTeamsPrimary() {
            return (this.config.navigation?.primary || []).find((item) => item.id === 'teams') || null;
        }

        getPlayersSearchSub() {
            const allSub = (this.config.navigation?.subcategories?.players || []).find(
                (sub) => sub.id === 'all' || sub.label === 'All'
            );
            if (allSub) return this.mapSubToSearchCol('players', allSub);

            const primary = (this.config.navigation?.primary || []).find((item) => item.id === 'players');
            if (!primary?.handle) return null;
            return { primaryId: 'players', id: 'all', handle: primary.handle, label: primary.label };
        }

        getProductPlayerLabel(product) {
            this.enrichProductCategoryMeta(product);
            return String(this.getProductMeta(product).player || '').trim();
        }

        getProductCountryLabel(product) {
            this.enrichProductCategoryMeta(product);
            const meta = this.getProductMeta(product);
            return String(meta.club || meta.category || meta.collectionTitle || '').trim();
        }

        getProductSearchCountryLabel(product) {
            this.enrichProductCategoryMeta(product);
            const meta = this.getProductMeta(product);
            return String(meta.club || meta.category || '').trim();
        }

        _getProductsForSub(handle, sub) {
            let products = this.getProductsForHandle(handle);
            if (sub?.filterBy) {
                products = this.filterProductsByMetafield(products, sub.filterBy, sub.filterValue);
            }
            return products;
        }

        getSearchCollectionProducts(col) {
            return this._getProductsForSub(col.handle, col);
        }

        _exitSearchSession({ blurInput = true } = {}) {
            const input = this.querySelector('[data-bundle-search-input]');
            this.searchQuery = '';
            this.searchResults = null;
            this.searchMode = false;
            this.browsingSnapshot = null;
            if (input) {
                input.value = '';
                if (blurInput && document.activeElement === input) input.blur();
            }
        }

        isPlayersNavAlias(playerKey) {
            return (this.config.navigation?.subcategories?.players || []).some((sub) => {
                if (!sub.filterBy) return false;
                return (
                    this.normalizeMetaValue(sub.filterValue) === playerKey ||
                    this.normalizeMetaValue(sub.label) === playerKey
                );
            });
        }

        buildPlayerSearchResults(query) {
            const col = this.getPlayersSearchSub();
            if (!col) return [];

            const q = String(query || '').toLowerCase();
            const navResults = this.buildMetafieldSearchResults('players', q).map((item) => {
                item.matchCount = (item.products || []).length;
                return item;
            });

            const playerMap = new Map();
            this.getProductsForHandle(col.handle).forEach((product) => {
                const player = this.getProductPlayerLabel(product);
                if (!player) return;

                const key = this.normalizeMetaValue(player);
                if (this.isPlayersNavAlias(key)) return;

                if (!playerMap.has(key)) {
                    playerMap.set(key, { label: player, products: [] });
                }
                playerMap.get(key).products.push(product);
            });

            const dynamicResults = [...playerMap.values()]
                .filter((entry) => this.searchNameMatchesQuery(entry.label, q))
                .map((entry) => this.createSearchCollectionEntry({ label: entry.label }, entry.products, q));

            return [...navResults, ...dynamicResults];
        }

        buildMetafieldSearchResults(primaryId, query) {
            const q = String(query || '').toLowerCase();
            return this.getNavSubcategories(primaryId, { metafieldOnly: true }).reduce((results, sub) => {
                const col = this.mapSubToSearchCol(primaryId, sub);
                if (!this.searchSubcategoryMatchesQuery(col, q)) return results;

                const products = this.getSearchCollectionProducts(col);
                if (!products.length) return results;

                results.push(this.createSearchCollectionEntry(col, products, q));
                return results;
            }, []);
        }

        buildDynamicClubSearchResults(query, excludedKeys = new Set()) {
            const q = String(query || '').toLowerCase();
            const clubMap = new Map();

            this.catalog.forEach((product) => {
                if (!this.isBundleEligibleProduct(product)) return;

                this.enrichProductCategoryMeta(product);
                const meta = this.getProductMeta(product);
                // Country label sources: football_club, custom_category, first collection title
                const club = String(meta.club || meta.category || meta.collectionTitle || '').trim();
                if (!club) return;

                const key = this.normalizeMetaValue(club);
                if (excludedKeys.has(key)) return;

                if (!clubMap.has(key)) {
                    clubMap.set(key, { label: club, products: [], matchingProducts: [] });
                }

                const entry = clubMap.get(key);
                entry.products.push(product);
                if (this.productMatchesSearch(product, q)) {
                    entry.matchingProducts.push(product);
                }
            });

            return [...clubMap.values()]
                .filter(
                    (entry) =>
                        this.searchSubcategoryMatchesQuery({ label: entry.label, filterValue: entry.label }, q) ||
                        entry.matchingProducts.length
                )
                .map((entry) => this.createSearchCollectionEntry(entry, entry.products, q));
        }

        buildCountrySearchResults(query) {
            const col = this.getCountriesSearchSub();
            if (!col) return [];

            const q = String(query || '').toLowerCase();
            const products = this.getSearchCollectionProducts(col);
            const clubMap = new Map();

            products.forEach((product) => {
                const club = this.getProductSearchCountryLabel(product);
                if (!club) return;

                const key = this.normalizeMetaValue(club);
                if (!clubMap.has(key)) {
                    clubMap.set(key, { label: club, products: [], matchingProducts: [] });
                }

                const entry = clubMap.get(key);
                entry.products.push(product);
                if (this.productMatchesSearch(product, q)) entry.matchingProducts.push(product);
            });

            return [...clubMap.values()]
                .filter(
                    (entry) =>
                        this.searchSubcategoryMatchesQuery({ label: entry.label, filterValue: entry.label }, q) ||
                        entry.matchingProducts.length
                )
                .map((entry) => {
                    const labelMatches = this.searchSubcategoryMatchesQuery(
                        { label: entry.label, filterValue: entry.label },
                        q
                    );
                    const products = labelMatches ? entry.products : entry.matchingProducts;
                    return this.createSearchCollectionEntry({ label: entry.label }, products, q);
                });
        }

        getProductMeta(product) {
            return product._categoryLabelMeta || this.config.productLabels?.[product.handle] || {};
        }


        getSearchExcludeTerms() {
            const nav = this.config.navigation || {};
            const subs = nav.subcategories || {};
            const countries = new Set();
            const players = new Set();
            const leagues = new Set();

            const addLabel = (set, label) => {
                const value = this.normalizeMetaValue(label);
                if (value && value !== 'all') set.add(value);
            };

            (subs.international || []).forEach((sub) => {
                addLabel(countries, sub.label);
                addLabel(countries, sub.filterValue);
            });
            (subs.players || []).forEach((sub) => {
                addLabel(players, sub.label);
                addLabel(players, sub.filterValue);
            });
            (subs.teams || []).forEach((sub) => addLabel(leagues, sub.label));

            this.catalog.forEach((product) => {
                if (!this.isBundleEligibleProduct(product)) return;
                const player = this.getProductMeta(product).player;
                if (player) addLabel(players, player);
            });

            return { countries, players, leagues };
        }

        isValidTeamName(name, meta) {
            const value = String(name || '').trim();
            if (!value || value.length < 2) return false;

            const lower = value.toLowerCase();
            const exclude = this.getSearchExcludeTerms();

            if (exclude.countries.has(lower)) return false;
            if (exclude.leagues.has(lower)) return false;

            for (const player of exclude.players) {
                if (lower === player) return false;
            }

            if (meta?.player) {
                const player = String(meta.player).replace(/®/g, '').trim().toLowerCase();
                if (lower === player) return false;
            }

            const blocklist = [
                'jersey',
                'jerseys',
                'edition',
                'heritage',
                'comma',
                'pulga',
                'moment',
                'moments',
                'world cup',
                'bundle',
            ];
            if (blocklist.some((term) => lower.includes(term))) return false;

            return true;
        }

        resolveProductClubName(product) {
            const meta = this.getProductMeta(product);

            const tryName = (name) => {
                const value = String(name || '').trim();
                return value && this.isValidTeamName(value, meta) ? value : '';
            };

            let club = tryName(meta.club);
            if (club) return club;

            club = tryName(meta.team);
            if (club) return club;

            for (const tag of product.tags || []) {
                const prefixed = tag.match(/^(?:team|club)[_:\-](.+)$/i);
                if (prefixed) {
                    club = tryName(prefixed[1].replace(/-/g, ' '));
                    if (club) return club;
                }
            }

            return '';
        }

        buildTeamSearchSubtitle(item, query) {
            const allProducts = item.products || [];
            const matchingProducts =
                item.matchingProducts || allProducts.filter((product) => this.productMatchesSearch(product, query));
            const players = [];

            const addPlayer = (product, priority) => {
                const meta = this.getProductMeta(product);
                if (!meta.player) return;
                const name = String(meta.player).trim();
                if (!name) return;

                const key = name.toLowerCase();
                const existingIndex = players.findIndex((player) => player.toLowerCase() === key);
                if (existingIndex >= 0) {
                    if (priority && existingIndex > 0) {
                        const [existing] = players.splice(existingIndex, 1);
                        players.unshift(existing);
                    }
                    return;
                }

                if (priority) players.unshift(name);
                else players.push(name);
            };

            matchingProducts.forEach((product) => addPlayer(product, true));
            allProducts.forEach((product) => addPlayer(product, false));

            if (!players.length) return '';
            return highlightSearchText(players.slice(0, 2).join(' · '), query);
        }

        buildTeamSearchResults(query) {
            const primary = this.getTeamsPrimary();
            if (!primary?.handle) return [];

            const q = String(query || '').toLowerCase();
            const products = this.getProductsForHandle(primary.handle);
            const clubMap = new Map();

            products.forEach((product) => {
                const club = this.resolveProductClubName(product);
                if (!club) return;

                const key = this.normalizeMetaValue(club);
                if (!clubMap.has(key)) {
                    clubMap.set(key, { label: club, products: [], matchingProducts: [] });
                }

                const entry = clubMap.get(key);
                entry.products.push(product);
                if (this.productMatchesSearch(product, q)) entry.matchingProducts.push(product);
            });

            return [...clubMap.values()]
                .filter(
                    (entry) =>
                        this.searchSubcategoryMatchesQuery({ label: entry.label }, q) ||
                        entry.matchingProducts.length
                )
                .map((entry) => this.createSearchCollectionEntry({ label: entry.label }, entry.products, q));
        }

        buildCollectionSearchSubtitle(item, query, groupKey) {
            if (groupKey === 'team') return this.buildTeamSearchSubtitle(item, query);

            const products = (item.products || []).filter((product) => this.productMatchesSearch(product, query));
            const source = products.length ? products : item.products || [];
            const players = [];

            source.forEach((product) => {
                const meta = this.getProductMeta(product);
                if (!meta.player) return;
                const name = String(meta.player);
                if (!players.some((player) => player.toLowerCase() === name.toLowerCase())) players.push(name);
            });

            if (players.length >= 2) return highlightSearchText(players.slice(0, 2).join(' · '), query);
            if (players.length === 1) return highlightSearchText(`${players[0]} · ${item.label}`, query);
            return highlightSearchText(item.label, query);
        }

        getPlayerCollectionTitle(label) {
            return /jerseys?/i.test(label) ? label : `${label} Jerseys`;
        }

        formatSearchAvailableCount(count) {
            const template = this.copy.searchAvailableCount || '{count} available';
            return escapeHtml(template.replace('{count}', count));
        }

        getProductSearchSubtitle(product) {
            const meta = this.getProductMeta(product);
            const parts = [];
            if (meta.player) parts.push(String(meta.player));
            if (meta.club) parts.push(String(meta.club));
            return parts.join(' · ');
        }

        buildSearchProductResultHtml(product, query) {
            const subtitle = this.getProductSearchSubtitle(product);
            const { price, compareAt } = this.getProductPrice(product);
            const image = this.getProductImage(product);

            return `
        <button type="button" class="${tn}-bundle-products__search-result" data-action="search-select-product" data-product-id="${product.id}">
          <div class="${tn}-bundle-products__search-result-media">
            <img src="${escapeHtml(image)}" alt="${escapeHtml(product.title)}" loading="lazy" width="72" height="72" onerror="this.style.display='none'" />
          </div>
          <div class="${tn}-bundle-products__search-result-body">
            <div class="${tn}-bundle-products__search-result-main">
              <p class="${tn}-bundle-products__search-result-title">${highlightSearchText(product.title, query)}</p>
              ${subtitle ? `<p class="${tn}-bundle-products__search-result-meta">${highlightSearchText(subtitle, query)}</p>` : ''}
            </div>
            <div class="${tn}-bundle-products__search-result-prices">
              <span class="${tn}-bundle-products__search-result-price${compareAt > 0 ? '' : ` ${tn}-bundle-products__search-result-price--regular`}">${this.formatMoney(price)}</span>
              ${compareAt > 0 ? `<s class="${tn}-bundle-products__search-result-compare">${this.formatMoney(compareAt)}</s>` : ''}
            </div>
          </div>
        </button>
      `;
        }

        buildSearchCollectionResultHtml(item, groupKey, query) {
            const isClub = groupKey === 'team' && !item.primaryId;
            const isCountry = groupKey === 'country' && !item.primaryId;
            const isPlayer = groupKey === 'players' && !item.primaryId;
            const title =
                isClub || isCountry
                    ? item.label
                    : groupKey === 'players'
                        ? this.getPlayerCollectionTitle(item.label)
                        : item.label;
            const subtitle =
                groupKey === 'players'
                    ? this.formatSearchAvailableCount(item.matchCount)
                    : this.buildCollectionSearchSubtitle(item, query, groupKey);
            const image = item.image || this.config.placeholderSlotImage || '';
            const action = isClub || isCountry ? 'search-select-club' : isPlayer ? 'search-select-player' : 'search-select-collection';
            const actionAttrs = isClub || isCountry
                ? `data-club="${escapeHtml(item.label)}" data-search-group="${isCountry ? 'country' : 'team'}"`
                : isPlayer
                    ? `data-player="${escapeHtml(item.label)}"`
                    : `data-primary-id="${escapeHtml(item.primaryId)}" data-sub-id="${escapeHtml(item.id || item.handle)}"`;

            return `
        <button type="button" class="${tn}-bundle-products__search-result" data-action="${action}" ${actionAttrs}>
          <div class="${tn}-bundle-products__search-result-media">
            <img src="${escapeHtml(image)}" alt="${escapeHtml(title)}" loading="lazy" width="72" height="72" onerror="this.style.display='none'" />
          </div>
          <div class="${tn}-bundle-products__search-result-body">
            <div class="${tn}-bundle-products__search-result-main">
              <p class="${tn}-bundle-products__search-result-title">${highlightSearchText(title, query)}</p>
              <p class="${tn}-bundle-products__search-result-meta">${subtitle}</p>
            </div>
          </div>
        </button>
      `;
        }

        buildSearchResultsHtml() {
            const query = this.searchQuery;
            const c = this.copy;
            const groups = [
                { key: 'players', label: c.searchCategoryPlayers || 'Players' },
                { key: 'jerseys', label: c.searchCategoryJerseys || 'Jerseys' },
                { key: 'country', label: c.searchCategoryCountry || 'Country' },
                { key: 'team', label: c.searchCategoryTeam || 'Team' },
            ];
            const activeGroups = groups.filter((group) => this.searchResults?.[group.key]?.length);

            return activeGroups.reduce((html, group, index) => {
                html += `<div class="${tn}-bundle-products__search-dropdown-group">`;
                html += `<p class="${tn}-bundle-products__search-dropdown-category">${escapeHtml(group.label)}</p>`;
                html += this.searchResults[group.key].reduce((itemsHtml, item) => {
                    itemsHtml +=
                        group.key === 'jerseys'
                            ? this.buildSearchProductResultHtml(item, query)
                            : this.buildSearchCollectionResultHtml(item, group.key, query);
                    return itemsHtml;
                }, '');
                html += `</div>`;
                if (index < activeGroups.length - 1) {
                    html += `<div class="${tn}-bundle-products__search-dropdown-divider" aria-hidden="true"></div>`;
                }
                return html;
            }, '');
        }

        renderSearchDropdown() {
            const dropdown = this.querySelector('[data-bundle-search-dropdown]');
            if (!dropdown) return;

            const c = this.copy;
            const chips = this.buildSearchChipsHtml();
            const noResults = !!this.searchQuery && !this.hasSearchResults();

            if (noResults) {
                dropdown.innerHTML = `
          <span class="${tn}-bundle-products__search-dropdown-icon" aria-hidden="true">${SEARCH_EMPTY_ICON_SVG}</span>
          <div class="${tn}-bundle-products__search-dropdown-head">
            <p class="${tn}-bundle-products__search-dropdown-title">${escapeHtml(c.emptySearchTitle)} “${escapeHtml(this.searchQuery)}”</p>
            <p class="${tn}-bundle-products__search-dropdown-hint">${escapeHtml(c.emptySearchHint)}</p>
          </div>
          <div class="${tn}-bundle-products__search-chips">${chips}</div>
        `;
                return;
            }

            if (this.searchQuery && this.hasSearchResults()) {
                dropdown.innerHTML = this.buildSearchResultsHtml();
                return;
            }

            dropdown.innerHTML = `
        <div class="${tn}-bundle-products__search-dropdown-head">
          <p class="${tn}-bundle-products__search-dropdown-title">${escapeHtml(c.searchDropdownTitle)}</p>
          <p class="${tn}-bundle-products__search-dropdown-hint">${escapeHtml(c.searchDropdownHint)}</p>
        </div>
        <div class="${tn}-bundle-products__search-chips">${chips}</div>
      `;
        }

        async buildSearchResults(query) {
            await this.ensureFullRootCatalog();
            const q = query.toLowerCase();
            const results = { players: [], jerseys: [], country: [], team: [] };

            this.catalog.forEach((product) => {
                if (!this.isBundleEligibleProduct(product)) return;
                if (!this.productMatchesSearch(product, q)) return;
                results.jerseys.push(product);
            });

            results.players = this.buildPlayerSearchResults(q);
            results.country = this.buildCountrySearchResults(q);
            results.team = this.buildTeamSearchResults(q);

            const countryKeys = new Set(
                results.country
                    .map((entry) => this.normalizeMetaValue(entry.filterValue || entry.label))
                    .filter(Boolean)
            );
            results.team = results.team.filter((entry) => {
                const key = this.normalizeMetaValue(entry.filterValue || entry.label);
                return !key || !countryKeys.has(key);
            });

            return results;
        }

        _cacheSearchNavigationResults(results) {
            const countries = new Map();
            const teams = new Map();
            const players = new Map();

            const cacheItem = (item, map) => {
                if (item?.primaryId || !item?.products?.length) return;
                const key = this.normalizeMetaValue(item.label);
                if (key) map.set(key, item.products);
            };

            (results.country || []).forEach((item) => cacheItem(item, countries));
            (results.team || []).forEach((item) => cacheItem(item, teams));
            (results.players || []).forEach((item) => cacheItem(item, players));

            this._searchNavCache = { clubs: countries, teams, players };
        }

        _applySearchGridView(products) {
            this.filteredProducts = products;
            this.updateSearchControls();
            this.renderNav();
            this.renderGrid();
            this.renderEmptyState();
        }

        captureSearchJerseys() {
            return [...(this.searchResults?.jerseys || [])];
        }

        uniqueProducts(products) {
            const seen = new Set();
            return (products || []).filter((product) => {
                if (!product || seen.has(product.id)) return false;
                seen.add(product.id);
                return true;
            });
        }

        orderBySearchQuery(products, query) {
            const q = String(query || '').toLowerCase();
            if (!q) return products || [];
            const matching = [];
            const rest = [];
            (products || []).forEach((product) => {
                (this.productMatchesSearch(product, q) ? matching : rest).push(product);
            });
            return [...matching, ...rest];
        }

        pinProductFirst(products, product) {
            const rest = (products || []).filter((item) => item.id !== product.id);
            return [product, ...rest];
        }

        enterSearchGrid(products) {
            this.searchGridActive = true;
            this.activePrimaryId = '';
            this.activeSubId = '';
            this.activeSubHandle = '';
            this._collectionLoadId += 1;
            this._searchNavCache = null;
            this.clearPendingSelection();
            this._applySearchGridView(products || []);
        }

        getSearchCountryProducts(key) {
            const cached = this._searchNavCache?.clubs?.get(key);
            if (cached?.length) return [...cached];

            const products = [];
            const countriesSub = this.getCountriesSearchSub();
            if (countriesSub) {
                this.getSearchCollectionProducts(countriesSub).forEach((product) => {
                    if (this.normalizeMetaValue(this.getProductCountryLabel(product)) === key) products.push(product);
                });
            }

            this.catalog.forEach((product) => {
                if (!this.isBundleEligibleProduct(product)) return;
                if (this.normalizeMetaValue(this.getProductCountryLabel(product)) === key) products.push(product);
            });

            return this.uniqueProducts(products);
        }

        getSearchTeamProducts(key) {
            const cached = this._searchNavCache?.teams?.get(key);
            if (cached?.length) return [...cached];

            const primary = this.getTeamsPrimary();
            if (!primary?.handle) return [];
            return this.getProductsForHandle(primary.handle).filter((product) => {
                return this.normalizeMetaValue(this.resolveProductClubName(product)) === key;
            });
        }

        async selectSearchProduct(productId) {
            if (this.isBundleFull()) return;

            let product = [...this.catalog.values()].find((item) => item.id === productId);
            if (!product || !this.isBundleEligibleProduct(product)) return;

            const jerseys = this.captureSearchJerseys();
            this._exitSearchSession();
            this.enterSearchGrid(this.pinProductFirst(jerseys.length ? jerseys : [product], product));
            await this.selectProduct(productId);
        }

        selectSearchCollection(primaryId, subId) {
            const subs = this.config.navigation?.subcategories?.[primaryId] || [];
            const sub = subs.find((item) => (item.id || item.handle) === subId);
            const handle = sub?.handle || subId;
            const products = this._getProductsForSub(handle, sub);

            this._exitSearchSession();
            this.enterSearchGrid(products);
        }

        selectSearchClub(clubName, group) {
            if (!clubName) return;

            const query = this.searchQuery;
            const searchJerseys = this.captureSearchJerseys();
            const key = this.normalizeMetaValue(clubName);
            const groupProducts =
                group === 'team' ? this.getSearchTeamProducts(key) : this.getSearchCountryProducts(key);

            this._exitSearchSession();
            this.enterSearchGrid(this.orderBySearchQuery(this.uniqueProducts([...groupProducts, ...searchJerseys]), query));
        }

        selectSearchPlayer(playerName) {
            if (!playerName) return;

            const query = this.searchQuery;
            const searchJerseys = this.captureSearchJerseys();
            const key = this.normalizeMetaValue(playerName);
            const cached = this._searchNavCache?.players?.get(key);
            const playersSub = this.getPlayersSearchSub();
            const playerProducts = cached?.length
                ? [...cached]
                : playersSub?.handle
                    ? this.getProductsForHandle(playersSub.handle).filter((product) => {
                        return this.normalizeMetaValue(this.getProductPlayerLabel(product)) === key;
                    })
                    : [];

            this._exitSearchSession();
            this.enterSearchGrid(
                this.orderBySearchQuery(this.uniqueProducts([...playerProducts, ...searchJerseys]), query)
            );
        }

        applySearchChip(chip) {
            const input = this.querySelector('[data-bundle-search-input]');
            if (input) input.value = chip;
            this.searchQuery = chip;
            this.enterSearchMode();
            this.updateSearchControls();
            this.applySearchFilter();
            input?.focus();
        }

        async ensureRootCatalog() {
            if (!this._rootCatalogInitPromise) {
                this._rootCatalogInitPromise = this._initRootCatalog();
            }
            return this._rootCatalogInitPromise;
        }

        async ensureFullRootCatalog() {
            await this.ensureRootCatalog();
            if (this._rootCatalogFullPromise) await this._rootCatalogFullPromise;
            return this.getEligibleJerseys();
        }

        async _initRootCatalog() {
            try {
                await this._loadRootCatalogStorefront();
            } catch (err) {
                console.error(`[${tn}-bundle-products] Storefront failed, Ajax fallback`, err);
                this._storefrontFailed = true;
                await this._loadRootCatalogAjax();
            }
            return this.getEligibleJerseys();
        }

        getEligibleJerseys() {
            const products = [];
            this.catalog.forEach((product) => {
                if (this.isBundleEligibleProduct(product)) products.push(product);
            });
            return products;
        }

        getStorefrontToken() {
            try {
                const features = document.getElementById('shopify-features');
                if (features?.innerHTML) {
                    const token = JSON.parse(features.innerHTML)?.accessToken;
                    if (token) return token;
                }
            } catch {
                /* ignore */
            }
            return '';
        }

        getStorefrontEndpoint() {
            const apiVersion = this.config.storefrontApi?.apiVersion || '2025-10';
            return this.buildCollectionUrl(`api/${apiVersion}/graphql.json`);
        }

        getStorefrontContext() {
            const locale = String(window.Shopify?.locale || this.config.storefrontApi?.locale || 'en').toUpperCase();
            const country = String(window.Shopify?.country || 'US').toUpperCase();
            return { locale, country };
        }

        async storefrontQuery(query, variables = {}, cacheSuffix = '') {
            const token = this.getStorefrontToken();
            if (!token) throw new Error('Storefront access token not found');

            const url = this.getStorefrontEndpoint();
            const body = JSON.stringify({ query, variables });
            const cacheKey = await digestCacheKey(`${url}${cacheSuffix}${body}`);

            try {
                const cached = sessionStorage.getItem(cacheKey);
                if (cached) return JSON.parse(cached);
            } catch {
                /* ignore */
            }

            const res = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': token,
                },
                body,
            });

            if (!res.ok) throw new Error(`Storefront request failed: ${res.status}`);

            const payload = await res.json();
            if (payload.errors?.length) {
                throw new Error(payload.errors.map((e) => e.message).join('; '));
            }

            try {
                sessionStorage.setItem(cacheKey, JSON.stringify(payload));
            } catch {
                /* ignore */
            }

            return payload;
        }

        _getJerseysQuery() {
            if (this._jerseysQueryCache) return this._jerseysQueryCache;

            const pageSize = this.config.storefrontApi?.collectionPageSize || 250;
            const { locale, country } = this.getStorefrontContext();
            this._jerseysQueryCache = `
                query BundleJerseys($handle: String!, $cursor: String) @inContext(country: ${country}, language: ${locale}) {
                    collection(handle: $handle) {
                        products(first: ${pageSize}, after: $cursor) {
                            nodes {
                                id
                                handle
                                title
                                vendor
                                productType
                                tags
                                featuredImage { url (transform: { maxWidth: 450 }) }
                                images(first: 1) { nodes { url(transform: { maxWidth: 450 }) } }
                                collections(first: 250) { nodes { handle title } }
                                player: metafield(namespace: "custom", key: "player") { value }
                                footballClub: metafield(namespace: "custom", key: "football_club") { value }
                                customCategory: metafield(namespace: "c_f", key: "custom_category") { value }
                                variants(first: 50) {
                                    nodes {
                                        id
                                        availableForSale
                                        price { amount }
                                        compareAtPrice { amount }
                                        selectedOptions { name value }
                                    }
                                }
                            }
                            pageInfo { hasNextPage endCursor }
                        }
                    }
                }
            `;
            return this._jerseysQueryCache;
        }

        normalizeStorefrontProduct(node) {
            const images = (node.images?.nodes || []).reduce((acc, img) => {
                if (img?.url) acc.push({ src: img.url });
                return acc;
            }, []);

            const featuredUrl = node.featuredImage?.url || '';
            if (featuredUrl && !images.some((img) => img.src === featuredUrl)) {
                images.unshift({ src: featuredUrl });
            }

            const collections = (node.collections?.nodes || []).reduce((acc, col) => {
                if (!col?.handle) return acc;
                acc.push({ handle: col.handle, title: col.title || '' });
                return acc;
            }, []);

            const optionNames = [];
            const variants = (node.variants?.nodes || []).reduce((acc, variant) => {
                const mapped = {
                    id: parseStorefrontGid(variant.id),
                    available: !!variant.availableForSale,
                    price: variant.price?.amount ?? 0,
                    compare_at_price: variant.compareAtPrice?.amount ?? null,
                };

                (variant.selectedOptions || []).forEach((option, index) => {
                    if (option?.name && !optionNames[index]) optionNames[index] = option.name;
                    if (option?.value) mapped[`option${index + 1}`] = option.value;
                });

                acc.push(mapped);
                return acc;
            }, []);

            return {
                id: parseStorefrontGid(node.id),
                handle: node.handle,
                title: node.title,
                vendor: node.vendor,
                product_type: node.productType,
                tags: node.tags || [],

                featured_image: featuredUrl || images[0]?.src || '',
                images,
                collections,
                variants,
                options: optionNames.filter(Boolean),
                _collectionHandles: collections.map((col) => col.handle),
                _storefrontMeta: {
                    player: node.player?.value || '',
                    club: node.footballClub?.value || '',
                    category: node.customCategory?.value || '',
                    collectionTitle: collections[0]?.title || '',
                },
                _detailLoaded: true,
            };
        }

        mergeCatalogProduct(existing, incoming) {
            if (!existing) return incoming;

            const handles = [...new Set([
                ...(existing._collectionHandles || []),
                ...(incoming._collectionHandles || []),
            ])];
            const collectionsByHandle = new Map();
            [...(existing.collections || []), ...(incoming.collections || [])].forEach((col) => {
                if (col?.handle) collectionsByHandle.set(col.handle, col);
            });

            incoming._collectionHandles = handles;
            incoming.collections = [...collectionsByHandle.values()];
            if (!incoming.tags?.length && existing.tags?.length) incoming.tags = existing.tags;
            if (!incoming._storefrontMeta && existing._storefrontMeta) {
                incoming._storefrontMeta = existing._storefrontMeta;
            }
            return incoming;
        }

        stampCollectionHandle(product, handle) {
            if (!product || !handle) return product;
            const handles = new Set(product._collectionHandles || []);
            if (!handles.has(handle)) {
                handles.add(handle);
                product._collectionHandles = [...handles];
                product.collections = [...(product.collections || []), { handle, title: '' }];
            }
            return product;
        }

        _ingestJerseyProducts(nodes, collectionHandle) {
            (nodes || []).forEach((node) => {
                const product = this.normalizeStorefrontProduct(node);
                this.stampCollectionHandle(product, collectionHandle);
                this.enrichProductCategoryMeta(product);
                this.catalog.set(
                    product.handle,
                    this.mergeCatalogProduct(this.catalog.get(product.handle), product)
                );
            });
        }

        _invalidateCollectionCache() {
            this.collectionCache.clear();
        }

        getProductsForHandle(handle) {
            if (this.collectionCache.has(handle)) {
                return [...this.collectionCache.get(handle)];
            }

            const products = this.filterProductsByCollectionHandle(this.getEligibleJerseys(), handle);
            this.collectionCache.set(handle, products);
            return [...products];
        }

        _getFilteredProductsForActiveTab() {
            const activeSub = this.getActiveSubcategory();
            const handle = activeSub?.handle || this.getActiveCollectionHandle();
            return this._getProductsForSub(handle, activeSub);
        }

        _schedulePaginationGridRefresh(loadId) {
            if (!this._debouncedPaginationGridRefresh) {
                this._debouncedPaginationGridRefresh = debounce((id) => {
                    this.mergeCatalogProductsIntoActiveGrid(id);
                }, 100);
            }
            this._debouncedPaginationGridRefresh(loadId);
        }

        productBelongsToCollection(product, handle) {
            if (!product || !handle) return false;
            const root = this.config.rootCollection;
            if (handle === root) return true;
            const handles = product._collectionHandles || (product.collections || []).map((col) => col.handle);
            return handles.includes(handle);
        }

        filterProductsByCollectionHandle(products, handle) {
            if (!handle) return products;
            return products.filter((product) => this.productBelongsToCollection(product, handle));
        }

        async _loadRootCatalogStorefront() {
            const handle = this.config.rootCollection;
            if (!handle) return;

            const query = this._getJerseysQuery();
            let cursor = null;
            let isFirstPage = true;
            let loadId = this._collectionLoadId;

            const loadPage = async () => {
                const suffix = `${handle}-${cursor || 'start'}-${this.getStorefrontContext().country}`;
                const { data } = await this.storefrontQuery(query, { handle, cursor }, suffix);
                const connection = data?.collection?.products;
                if (!connection) return null;

                this._ingestJerseyProducts(connection.nodes, handle);

                if (!isFirstPage && loadId === this._collectionLoadId && !this.searchMode && !this.searchGridActive) {
                    this._schedulePaginationGridRefresh(loadId);
                }
                if (isFirstPage) isFirstPage = false;

                return connection.pageInfo;
            };

            const firstPageInfo = await loadPage();
            if (!firstPageInfo) return;

            if (firstPageInfo.hasNextPage) {
                this._rootCatalogFullPromise = (async () => {
                    let nextCursor = firstPageInfo.endCursor;
                    while (nextCursor) {
                        cursor = nextCursor;
                        const pageInfo = await loadPage();
                        if (!pageInfo?.hasNextPage) break;
                        nextCursor = pageInfo.endCursor;
                    }
                    return this.getEligibleJerseys();
                })();
            } else {
                this._rootCatalogFullPromise = Promise.resolve(this.getEligibleJerseys());
            }
        }

        async _loadRootCatalogAjax() {
            // Ajax fallback: loads root collection only; sub-tabs fetch per-collection via _fetchCollectionProductsAjax.
            const handle = this.config.rootCollection;
            if (!handle) return;

            const products = this.filterBundleProducts(
                await this.fetchAllPages(
                    this.buildCollectionUrl(`collections/${handle}/products.json?limit=250&sort_by=manual`)
                )
            );

            products.forEach((product) => {
                product._detailLoaded = !!(product.variants?.length && product.variants[0]?.option1 !== undefined);
                this.enrichProductCategoryMeta(product);
                this.catalog.set(product.handle, product);
            });

            this._invalidateCollectionCache();
            this._rootCatalogFullPromise = Promise.resolve(this.getEligibleJerseys());
        }

        async loadCurrentCollection() {
            const loadId = ++this._collectionLoadId;
            const handle = this.getActiveSubcategory()?.handle || this.getActiveCollectionHandle();
            if (!handle) return;
            this.setLoading(true);
            try {
                await this.ensureRootCatalog();
                if (loadId !== this._collectionLoadId) return;

                let products = await this.fetchCollectionProducts(handle);
                const activeSub = this.getActiveSubcategory();
                if (activeSub?.filterBy) {
                    products = this.filterProductsByMetafield(products, activeSub.filterBy, activeSub.filterValue);
                }
                if (loadId !== this._collectionLoadId) return;

                this.filteredProducts = products;
            } catch (err) {
                if (loadId !== this._collectionLoadId) return;
                console.error(`[${tn}-bundle-products] load collection failed:`, handle, err);
                this.filteredProducts = [];
            } finally {
                if (loadId !== this._collectionLoadId) return;
                this.setLoading(false);
                this.renderAll();
            }

            this.ensureFullRootCatalog()
                .then(() => this.mergeCatalogProductsIntoActiveGrid(loadId))
                .catch(() => { });
        }

        mergeCatalogProductsIntoActiveGrid(loadId) {
            if (loadId !== this._collectionLoadId || this.searchMode || this.searchGridActive) return;

            const activeSub = this.getActiveSubcategory();
            const handle = activeSub?.handle || this.getActiveCollectionHandle();
            if (!handle) return;

            let extras = this.filterProductsByCollectionHandle(this.getEligibleJerseys(), handle);
            if (activeSub?.filterBy) {
                extras = this.filterProductsByMetafield(extras, activeSub.filterBy, activeSub.filterValue);
            }

            const seen = new Set(this.filteredProducts.map((product) => product.id));
            extras = extras.filter((product) => !seen.has(product.id));
            if (!extras.length) return;

            this.filteredProducts = [...this.filteredProducts, ...extras];
            this.safeRender(this.renderGrid, 'renderGrid');
            this.safeRender(this.renderEmptyState, 'renderEmptyState');
        }

        buildCollectionUrl(path) {
            const root = String(this.rootPath || '/');
            const normalizedRoot = root.endsWith('/') ? root : `${root}/`;
            return `${normalizedRoot}${String(path).replace(/^\//, '')}`;
        }

        async fetchCollectionProducts(handle) {
            await this.ensureRootCatalog();

            if (this._storefrontFailed) {
                return this._fetchCollectionProductsAjax(handle);
            }

            if (this.shouldUseDefaultCollectionOrder(handle)) {
                return this._fetchCollectionProductsStorefront(handle);
            }

            return this.getProductsForHandle(handle);
        }

        shouldUseDefaultCollectionOrder(handle) {
            if (!handle) return false;
            const handles = Array.isArray(this.config.defaultOrderHandles) ? this.config.defaultOrderHandles : [];
            return handles.includes(handle);
        }

        async _fetchCollectionProductsStorefront(handle) {
            if (!handle) return [];
            if (this.collectionCache.has(handle)) {
                return [...this.collectionCache.get(handle)];
            }

            const pending = this._storefrontCollectionPromises.get(handle);
            if (pending) return [...(await pending)];

            const load = (async () => {
                const query = this._getJerseysQuery();
                const orderedProducts = [];
                let cursor = null;
                let hasNextPage = true;
                const { country } = this.getStorefrontContext();

                while (hasNextPage) {
                    const suffix = `default-${handle}-${cursor || 'start'}-${country}`;
                    const { data } = await this.storefrontQuery(query, { handle, cursor }, suffix);
                    const connection = data?.collection?.products;
                    if (!connection) break;

                    (connection.nodes || []).forEach((node) => {
                        const product = this.normalizeStorefrontProduct(node);
                        this.stampCollectionHandle(product, handle);
                        this.enrichProductCategoryMeta(product);
                        const merged = this.mergeCatalogProduct(this.catalog.get(product.handle), product);
                        this.catalog.set(product.handle, merged);
                        if (this.isBundleEligibleProduct(merged)) {
                            orderedProducts.push(merged);
                        }
                    });

                    hasNextPage = !!connection.pageInfo?.hasNextPage;
                    cursor = hasNextPage ? connection.pageInfo?.endCursor : null;
                }

                this.collectionCache.set(handle, orderedProducts);
                return [...orderedProducts];
            })();

            this._storefrontCollectionPromises.set(handle, load);
            try {
                return await load;
            } finally {
                this._storefrontCollectionPromises.delete(handle);
            }
        }

        async _fetchCollectionProductsAjax(handle) {
            if (this.collectionCache.has(handle)) {
                return [...this.collectionCache.get(handle)];
            }

            const products = this.filterBundleProducts(
                await this.fetchAllPages(
                    this.buildCollectionUrl(`collections/${handle}/products.json?limit=250&sort_by=manual`)
                )
            );

            products.forEach((product) => {
                product._detailLoaded = !!(product.variants?.length && product.variants[0]?.option1 !== undefined);
                this.enrichProductCategoryMeta(product);
                this.catalog.set(product.handle, product);
            });

            this.collectionCache.set(handle, products);
            return [...products];
        }

        async fetchAllPages(url) {
            const items = [];
            let nextUrl = url;
            while (nextUrl) {
                const res = await fetch(nextUrl);
                if (!res.ok) {
                    console.error(`[${tn}-bundle-products] fetch failed:`, res.status, nextUrl);
                    break;
                }
                const data = await res.json();
                items.push(...(data.products || []));
                nextUrl = this.getNextPageUrl(data, nextUrl);
            }
            return items;
        }

        getNextPageUrl(data, currentUrl) {
            if (!data.products || data.products.length < 250) return null;
            const pageMatch = currentUrl.match(/[?&]page=(\d+)/);
            const page = pageMatch ? Number(pageMatch[1]) + 1 : 2;
            const base = currentUrl.replace(/([?&])page=\d+/, '').replace(/[?&]$/, '');
            const joiner = base.includes('?') ? '&' : '?';
            return `${base}${joiner}page=${page}`;
        }

        async applySearchFilter() {
            await this.ensureRootCatalog();
            const q = this.searchQuery.toLowerCase();
            if (!q) {
                if (this.browsingSnapshot) {
                    this.filteredProducts = [...this.browsingSnapshot.filteredProducts];
                }
                this.searchResults = null;
                this._searchNavCache = null;
                this.renderGrid();
                this.renderNav();
                this.updateSearchControls();
                return;
            }

            this.searchResults = await this.buildSearchResults(q);
            this._cacheSearchNavigationResults(this.searchResults);
            if (this.browsingSnapshot) {
                this.filteredProducts = [...this.browsingSnapshot.filteredProducts];
            }
            this.renderNav();
            this.updateSearchControls();
        }

        productMatchesSearch(product, q) {
            this.enrichProductCategoryMeta(product);
            const query = this.normalizeMetaValue(q);
            if (!query || query.length < 2) return false;

            const meta = this.getProductMeta(product);
            const tags = Array.isArray(product.tags)
                ? product.tags
                : String(product.tags || '')
                    .split(',')
                    .map((tag) => tag.trim())
                    .filter(Boolean);
            const fields = [product.title, meta.player, meta.club, meta.category, meta.team, ...tags];
            return fields.some((field) => this.normalizeMetaValue(field).includes(query));
        }

        getPrimaryItem() {
            return (this.config.navigation?.primary || []).find((p) => p.id === this.activePrimaryId);
        }

        getSubcategories() {
            return this.config.navigation?.subcategories?.[this.activePrimaryId] || null;
        }

        getActiveSubcategory() {
            const subs = this.getSubcategories();
            if (!subs?.length) return null;
            const subId = this.activeSubId || this.activeSubHandle;
            return subs.find((sub) => (sub.id || sub.handle) === subId) || subs[0];
        }

        getExcludedProductIds() {
            if (!this._excludedProductIds) {
                this._excludedProductIds = new Set(
                    (this.config.excludedProductIds || []).map((id) => Number(id)).filter(Boolean)
                );
            }
            return this._excludedProductIds;
        }

        getExcludedTitleTerms() {
            if (!this._excludedTitleTerms) {
                this._excludedTitleTerms = (this.config.excludedTitleTerms || [])
                    .map((term) => String(term || '').trim().toLowerCase())
                    .filter(Boolean);
            }
            return this._excludedTitleTerms;
        }

        getBundleProductType() {
            return String(this.config.productType || 'Jersey').trim().toLowerCase();
        }

        isJerseyProduct(product) {
            if (!product) return false;
            const type = String(product.product_type || product.type || '')
                .trim()
                .toLowerCase();
            return type === this.getBundleProductType();
        }


        isExcludedProduct(product) {
            if (!product) return false;
            if (this.getExcludedProductIds().has(Number(product.id))) return true;

            const title = String(product.title || '').toLowerCase();
            return this.getExcludedTitleTerms().some((term) => title.includes(term));
        }

        hasAvailableVariant(product) {
            return (product?.variants || []).some((variant) => variant.available);
        }

        isBundleEligibleProduct(product) {
            return (
                this.isJerseyProduct(product) &&
                !this.isExcludedProduct(product) &&
                this.hasAvailableVariant(product)
            );
        }

        filterBundleProducts(products) {
            return products.filter((product) => this.isBundleEligibleProduct(product));
        }

        normalizeMetaValue(value) {
            return String(value || '')
                .replace(/®/g, '')
                .trim()
                .toLowerCase();
        }

        productMatchesMetafieldFilter(product, filterBy, filterValue) {
            if (!filterBy) return true;

            this.enrichProductCategoryMeta(product);
            const meta = this.getProductMeta(product);

            if (filterValue != null && String(filterValue).trim() !== '') {
                const normalizedFilter = this.normalizeMetaValue(filterValue);
                const fields =
                    filterBy === 'club'
                        ? [meta.club, meta.category, meta.collectionTitle]
                        : [meta[filterBy]];
                return fields.some((field) => this.normalizeMetaValue(field) === normalizedFilter);
            }

            if (filterBy === 'club') {
                return [meta.club, meta.category, meta.collectionTitle].some(
                    (field) => field != null && String(field).trim() !== ''
                );
            }

            const value = meta[filterBy];
            return value != null && String(value).trim() !== '';
        }

        filterProductsByMetafield(products, filterBy, filterValue) {
            if (!filterBy) return products;
            return products.filter((product) => this.productMatchesMetafieldFilter(product, filterBy, filterValue));
        }

        getActiveCollectionHandle() {
            if (this.activeSubHandle) return this.activeSubHandle;
            return this.getPrimaryItem()?.handle || this.config.rootCollection;
        }

        setPrimaryTab(primaryId) {
            if (this.searchMode) return;
            this.searchGridActive = false;
            this.activePrimaryId = primaryId;
            const subs = this.getSubcategories();
            const first = subs?.[0];
            this.activeSubId = first?.id || first?.handle || this.getPrimaryItem()?.handle || '';
            this.activeSubHandle = first?.handle || this.getPrimaryItem()?.handle || '';
            this.selectedProductId = null;
            this.selectedSize = null;
            this.selectedProductData = null;
            this.loadCurrentCollection();
        }

        setSubTab(subId) {
            if (this.searchMode) return;
            this.searchGridActive = false;
            const subs = this.getSubcategories() || [];
            const sub = subs.find((item) => (item.id || item.handle) === subId);
            if (!sub) return;
            this.activeSubId = sub.id || sub.handle;
            this.activeSubHandle = sub.handle;
            this.selectedProductId = null;
            this.selectedSize = null;
            this.selectedProductData = null;
            this.loadCurrentCollection();
        }

        setLoading(isLoading) {
            this.loading = isLoading;
            this.querySelector('[data-bundle-loading]')?.classList.toggle('is-hidden', !isLoading);
        }

        safeRender(fn, label) {
            try {
                fn.call(this);
            } catch (err) {
                console.error(`[${tn}-bundle-products] ${label}`, err);
            }
        }

        renderAll() {
            this.safeRender(this.renderProgress, 'renderProgress');
            this.safeRender(this.renderNav, 'renderNav');
            this.safeRender(this.renderGrid, 'renderGrid');
            this.safeRender(this.renderEmptyState, 'renderEmptyState');
            this.safeRender(this.renderSizePanel, 'renderSizePanel');
            this.safeRender(this.renderAddButton, 'renderAddButton');
            this.safeRender(this.renderSidebar, 'renderSidebar');
            this.safeRender(this.renderMobileCta, 'renderMobileCta');
        }

        renderProgress() {
            const c = this.copy;
            const filledCount = this.slots.filter(Boolean).length;
            const steps = [
                { num: 1, label: c.jersey1 },
                { num: 2, label: c.jersey2 },
                { num: 3, label: c.checkout },
            ];

            const getStepState = (num) => {
                if (num === 1) {
                    if (filledCount >= 1) return 'completed';
                    return 'upcoming';
                }
                if (num === 2) {
                    if (filledCount >= 2) return 'completed';
                    if (filledCount >= 1) return 'active';
                    return 'upcoming';
                }
                if (filledCount >= 2) return 'active';
                return 'upcoming';
            };

            const html = `
        <div class="${tn}-bundle-products__progress-track">
          ${steps.reduce((acc, step, i) => {
                const state = getStepState(step.num);
                const circle =
                    state === 'completed'
                        ? `<span class="${tn}-bundle-products__progress-step ${tn}-bundle-products__progress-step--completed" aria-hidden="true">${COMPLETED_ICON_SVG}</span>`
                        : `<span class="${tn}-bundle-products__progress-step ${tn}-bundle-products__progress-step--${state}"><span>${step.num}</span></span>`;
                const divider =
                    i < steps.length - 1
                        ? `<span class="${tn}-bundle-products__progress-divider ${tn}-bundle-products__progress-divider--${state}"></span>`
                        : '';
                acc.push(circle + divider);
                return acc;
            }, [])
                    .join('')}
        </div>
        <div class="${tn}-bundle-products__progress-labels">
          ${steps.reduce((html, step) => {
                        html += `<span>${escapeHtml(step.label)}</span>`;
                        return html;
                    }, '')}
        </div>
      `;
            const el = this.querySelector('[data-bundle-progress]');
            if (el) el.innerHTML = html;
        }

        renderNav() {
            const el = this.querySelector('[data-bundle-nav]');
            if (!el) return;

            const nav = this.config.navigation || {};
            const primary = nav.primary || [];
            const subs = this.searchGridActive ? null : this.getSubcategories();
            const structureKey = `${this.searchGridActive ? 'search' : 'browse'}|${this.activePrimaryId}|${(subs || []).length}`;

            if (this._navRenderKey === structureKey && el.querySelector(`.${tn}-bundle-products__primary-nav`)) {
                this.syncNavActiveState(el);
                return;
            }

            const primaryNav = el.querySelector(`.${tn}-bundle-products__primary-nav`);
            const primaryScroll = primaryNav ? primaryNav.scrollLeft : 0;

            const primaryHtml = primary.reduce((html, item) => {
                html += `
          <button type="button" class="${tn}-bundle-products__primary-tab${!this.searchGridActive && item.id === this.activePrimaryId ? ' is-active' : ''}" data-action="primary-tab" data-primary-id="${escapeHtml(item.id)}">
            ${escapeHtml(item.label)}
          </button>
        `;
                return html;
            }, '');

            let subHtml = '';
            if (subs && subs.length) {
                const packedClass = subs.length > 3 ? ' is-packed' : '';
                subHtml = `
          <div class="${tn}-bundle-products__sub-nav${packedClass}">
            ${subs.reduce((html, sub) => {
                    const subId = sub.id || sub.handle;
                    const isActive = (this.activeSubId || this.activeSubHandle) === subId;
                    html += `
              <button type="button" class="${tn}-bundle-products__sub-tab${isActive ? ' is-active' : ''}" data-action="sub-tab" data-sub-id="${escapeHtml(subId)}" data-handle="${escapeHtml(sub.handle)}">
                ${escapeHtml(sub.label)}
              </button>
            `;
                    return html;
                }, '')}
            <span></span>
          </div>
        `;
            }

            this._navRenderKey = structureKey;
            el.innerHTML = `
          <div class="${tn}-bundle-products__primary-nav">${primaryHtml}<span></span></div>
          ${subHtml ? `<div class="${tn}-bundle-products__nav-divider"></div>${subHtml}` : ''}
        `;

            const nextPrimaryNav = el.querySelector(`.${tn}-bundle-products__primary-nav`);
            if (nextPrimaryNav) nextPrimaryNav.scrollLeft = primaryScroll;
        }

        syncNavActiveState(navRoot) {
            navRoot.querySelectorAll(`.${tn}-bundle-products__primary-tab`).forEach((tab) => {
                tab.classList.toggle('is-active', !this.searchGridActive && tab.dataset.primaryId === this.activePrimaryId);
            });

            const activeSubId = this.activeSubId || this.activeSubHandle;
            navRoot.querySelectorAll(`.${tn}-bundle-products__sub-tab`).forEach((tab) => {
                tab.classList.toggle('is-active', tab.dataset.subId === activeSubId);
            });
        }

        getCutline(product) {
            if (!product) return '';
            const tags = product.tags || [];
            const playerTag = tags.find((t) => /^player[:_]/i.test(t));
            if (playerTag) return playerTag.replace(/^player[:_]/i, '');
            if (product.vendor && product.vendor !== 'Comma Football') return product.vendor;
            return '';
        }

        enrichProductCategoryMeta(product) {
            if (!product?.handle) return product;

            const fromLabels = this.config.productLabels?.[product.handle] || {};
            const fromStorefront = product._storefrontMeta || {};
            const fromCollections = product.collections?.[0]?.title || '';

            const meta = {
                player: fromStorefront.player || fromLabels.player || '',
                club: fromStorefront.club || fromLabels.club || '',
                category: fromStorefront.category || fromLabels.category || '',
                collectionTitle:
                    fromStorefront.collectionTitle || fromLabels.collectionTitle || fromCollections || '',
            };

            product._categoryLabelMeta = {
                ...meta,
                team: meta.club || '',
            };

            // Keep productLabels in sync for products missing from liquid dump 
            if (!this.config.productLabels) this.config.productLabels = {};
            if (!this.config.productLabels[product.handle]) {
                this.config.productLabels[product.handle] = { ...meta };
            } else {
                this.config.productLabels[product.handle] = {
                    ...this.config.productLabels[product.handle],
                    player: this.config.productLabels[product.handle].player || meta.player || null,
                    club: this.config.productLabels[product.handle].club || meta.club || null,
                    category: this.config.productLabels[product.handle].category || meta.category || null,
                    collectionTitle:
                        this.config.productLabels[product.handle].collectionTitle || meta.collectionTitle || null,
                };
            }

            return product;
        }

        getProductCollectionLabel(product) {
            const sharedHandles = this.getSharedCollectionHandles();

            for (const collection of product?.collections || []) {
                if (!collection?.handle || sharedHandles.has(collection.handle)) continue;

                const navLabel = this.collectionLabels.get(collection.handle);
                if (navLabel) return navLabel;
                if (collection.title) return String(collection.title);
            }

            return '';
        }

        getCategoryLabel(product) {
            const cfg = this.config.categoryLabels;
            if (!cfg || !product) return '';

            this.enrichProductCategoryMeta(product);
            const meta = product._categoryLabelMeta || this.config.productLabels?.[product.handle] || {};
            const filterBy = this.getActiveSubcategory()?.filterBy;

            // Match theme category-labels.liquid priority
            if (cfg.enableCustomCategoryLabel) {
                if (filterBy === 'club' && (meta.club || meta.category || meta.collectionTitle)) {
                    return String(meta.club || meta.category || meta.collectionTitle);
                }
                if (filterBy === 'player' && meta.player) return String(meta.player);

                if (meta.player) return String(meta.player);
                if (meta.club) return String(meta.club);
                if (meta.category) return String(meta.category);
            }

            if (cfg.enableCollectionLabel) {
                return this.getProductCollectionLabel(product) || String(meta.collectionTitle || '');
            }

            return '';
        }

        buildCategoryLabelsHtml(product) {
            const label = this.getCategoryLabel(product);
            if (!label) return '';

            const cfg = this.config.categoryLabels || {};
            const style = [
                `--text-color:${cfg.color || '#6a6a6a'}`,
                `--font-size:${cfg.fontSize || 12}px`,
                `--tb-font-size:${cfg.fontSizeTb || 12}px`,
                `--mb-font-size:${cfg.fontSizeMb || 12}px`,
            ].join(';');

            return `<div class="category-labels-wrapper" style="${style}"><p class="extended-color extended-font-size">${escapeHtml(label)}</p></div>`;
        }

        getProductPrice(product) {
            const variant = this.getFirstAvailableVariant(product);
            if (!variant) return { price: 0, compareAt: 0 };
            const price = this.normalizeToCents(variant.price);
            const compareAt = this.normalizeToCents(variant.compare_at_price);
            return { price, compareAt: compareAt > price ? compareAt : 0 };
        }

        getFirstAvailableVariant(product) {
            return (product?.variants || []).find((v) => v.available) || product?.variants?.[0];
        }

        getProductImage(product) {
            if (product?.images?.length) {
                const src = product.images[0].src || product.images[0];
                return src.startsWith('//') ? `https:${src}` : src;
            }
            if (product?.featured_image) {
                const src = product.featured_image;
                return src.startsWith('//') ? `https:${src}` : src;
            }
            return '';
        }

        renderGrid() {
            const grid = this.querySelector('[data-bundle-grid]');
            if (!grid) return;

            const isBundleFull = this.isBundleFull();
            grid.closest(`.${tn}-bundle-products__grid-wrap`)?.classList.toggle('is-bundle-full', isBundleFull);

            if (isBundleFull) {
                this.clearPendingSelection();
            }

            if (!this.filteredProducts.length) {
                grid.innerHTML = '';
                return;
            }

            grid.innerHTML = this.filteredProducts
                .reduce((html, product) => {
                    const { price, compareAt } = this.getProductPrice(product);
                    const isSelected = this.selectedProductId === product.id;
                    const image = this.getProductImage(product);
                    const isLocked = isBundleFull;

                    html += `
            <article class="${tn}-bundle-products__card${isSelected ? ' ${tn}-bundle-products__card--selected' : ''}${isLocked ? ' ${tn}-bundle-products__card--locked' : ''}"${isLocked ? '' : ' data-action="select-product"'} data-product-id="${product.id}" tabindex="${isLocked ? '-1' : '0'}" role="button" aria-disabled="${isLocked ? 'true' : 'false'}">
              <div class="${tn}-bundle-products__card-media">
                <img src="${escapeHtml(image)}" alt="${escapeHtml(product.title)}" loading="lazy" width="318" height="476" onerror="this.style.display='none'" />
              </div>
              <div class="${tn}-bundle-products__card-info">
                ${this.buildCategoryLabelsHtml(product)}
                <h3 class="${tn}-bundle-products__card-title">${escapeHtml(product.title)}</h3>
                <div class="${tn}-bundle-products__card-prices">
                  <span class="${tn}-bundle-products__card-price${compareAt > 0 ? ` ${tn}-bundle-products__card-price--sale` : ''}">${this.formatMoney(price)}</span>
                  ${compareAt > 0 ? `<s class="${tn}-bundle-products__card-compare">${this.formatMoney(compareAt)}</s>` : ''}
                </div>
              </div>
            </article>
          `;
                    return html;
                }, '');

        }

        renderEmptyState() {
            this.querySelector('[data-bundle-empty]')?.classList.add('is-hidden');
        }

        async selectProduct(productId) {
            if (this.isBundleFull()) return;

            if (this.selectedProductId === productId) {
                this.clearPendingSelection();
                this.updateGridSelection();
                this.renderSizePanel();
                this.renderAddButton();
                return;
            }

            let product = this.filteredProducts.find((p) => p.id === productId);
            if (!product) {
                product = [...this.catalog.values()].find((p) => p.id === productId);
            }
            if (!product || !this.isBundleEligibleProduct(product)) return;

            this.selectedProductId = productId;
            this.selectedSize = null;
            this.selectedProductData = await this.resolveProductDetails(product.handle);
            if (!this.isBundleEligibleProduct(this.selectedProductData)) {
                this.selectedProductId = null;
                this.selectedProductData = null;
                return;
            }
            this.updateGridSelection();
            this.renderSizePanel();
            this.renderAddButton();
        }

        updateGridSelection() {
            const grid = this.querySelector('[data-bundle-grid]');
            if (!grid) return;

            grid.querySelectorAll('[data-product-id]').forEach((card) => {
                const productId = Number(card.dataset.productId);
                card.classList.toggle(`${tn}-bundle-products__card--selected`, productId === this.selectedProductId);
            });
        }

        async resolveProductDetails(handle) {
            const cached = this.catalog.get(handle);
            if (this.isCatalogProductReady(cached)) return cached;
            return this.fetchProductDetails(handle);
        }

        isCatalogProductReady(product) {
            if (!product?.id) return false;
            if (product._ajaxDetailLoaded) return true;
            return !this._storefrontFailed && !!product._detailLoaded;
        }

        async fetchProductDetails(handle) {
            const cached = this.catalog.get(handle);
            if (cached?._ajaxDetailLoaded) return cached;
            if (this.isCatalogProductReady(cached)) return cached;

            try {
                const res = await fetch(this.buildCollectionUrl(`products/${handle}.js`));
                if (!res.ok) return cached;
                const data = await res.json();
                data._ajaxDetailLoaded = true;
                data._detailLoaded = true;
                this.enrichProductCategoryMeta(data);
                this.catalog.set(handle, this.mergeCatalogProduct(cached, data));
                return this.catalog.get(handle);
            } catch {
                return cached;
            }
        }

        getSizeOptionIndex(product) {
            const options = product?.options || [];
            for (let i = 0; i < options.length; i++) {
                if (SIZE_OPTION_NAMES.includes(String(options[i]).toLowerCase())) return i;
            }
            return options.length === 1 ? 0 : -1;
        }

        getAvailableSizes(product) {
            const productData = product || this.selectedProductData;
            if (!productData) return [];
            const optionIndex = this.getSizeOptionIndex(productData);
            if (optionIndex < 0) {
                return (this.config.sizes || []).map((size) => ({
                    label: size,
                    available: true,
                    variant: productData.variants?.[0],
                }));
            }

            const optionKey = `option${optionIndex + 1}`;
            const configured = this.config.sizes || [];
            const sizeMap = new Map();

            (productData.variants || []).forEach((variant) => {
                const raw = variant[optionKey];
                if (!raw) return;
                const key = normalizeSize(raw);
                const existing = sizeMap.get(key);
                if (!existing || (variant.available && !existing.available)) {
                    sizeMap.set(key, { label: raw, available: variant.available, variant });
                }
            });

            if (configured.length) {
                return configured
                    .reduce((acc, size) => {
                        const key = normalizeSize(size);
                        const match = sizeMap.get(key);
                        if (match) acc.push(match);
                        else acc.push({ label: size, available: false, variant: null });
                        return acc;
                    }, []);
            }

            return [...sizeMap.values()];
        }

        selectSize(size) {
            if (this.isBundleFull()) return;
            this.selectedSize = size;
            this.renderSizePanel();
            this.renderAddButton();
        }

        renderSizePanel() {
            const panel = this.querySelector('[data-bundle-size-panel]');
            const dock = this.querySelector('[data-bundle-size-dock]');
            if (!panel) return;

            if (this.isBundleFull()) {
                this.clearPendingSelection();
            }

            const hasSelection = !this.isBundleFull() && !!this.selectedProductId && !!this.selectedProductData;
            panel.classList.toggle('is-disabled', !hasSelection);
            dock?.classList.toggle('is-disabled', !hasSelection);

            const sizes = hasSelection
                ? this.getAvailableSizes(this.selectedProductData)
                : (this.config.sizes || []).map((size) => ({ label: size, available: false, variant: null }));

            const sizesClass = hasSelection
                ? `${tn}-bundle-products__sizes`
                : `${tn}-bundle-products__sizes ${tn}-bundle-products__sizes--static`;

            panel.innerHTML = `
        <div class="${sizesClass}">
          ${sizes.reduce((html, item) => {
                const isActive = hasSelection && normalizeSize(this.selectedSize) === normalizeSize(item.label);
                const disabled = !hasSelection || !item.available;
                html += `<button type="button" class="${tn}-bundle-products__size-btn${isActive ? ' is-active' : ''}${disabled ? ' is-disabled' : ''}"${hasSelection && item.available ? ` data-action="select-size" data-size="${escapeHtml(item.label)}"` : ''} ${disabled ? 'disabled' : ''}>${escapeHtml(item.label)}</button>`;
                return html;
            }, '')}
          <span></span>
        </div>
      `;

            this.scheduleKiwiSync(hasSelection ? this.selectedProductData : null);
        }


        initSidebarHeightTracking() {
            const sidebar = this.querySelector('[data-bundle-sidebar]');
            if (!sidebar) return;

            if (!this._sidebarObserver) {
                this._sidebarObserver = new ResizeObserver(() => this._boundSidebarHeight());
                this._sidebarObserver.observe(sidebar);
            }

            this.updateSidebarHeightVar();
        }

        getHeaderMeasureTargets() {
            const header = document.querySelector(HEADER_SELECTOR) || document.querySelector('.theme__header');
            const bars = HEADER_BAR_SELECTORS.map((selector) => document.querySelector(selector));
            return [header, ...bars].filter(Boolean);
        }

        getHeaderOffsetHeight() {
            const heights = this.getHeaderMeasureTargets().map((el) => {
                const style = window.getComputedStyle(el);
                if (style.display === 'none' || style.visibility === 'hidden') return 0;
                if (Number.parseFloat(style.maxHeight) === 0) return 0;
                return el.getBoundingClientRect().height;
            });
            const measured = Math.max(0, ...heights);
            if (measured > 1) return Math.ceil(measured);

            const themeVar = Number.parseFloat(
                getComputedStyle(document.documentElement).getPropertyValue('--header-height')
            );
            return Number.isFinite(themeVar) && themeVar > 1 ? Math.ceil(themeVar) : 0;
        }

        initHeaderHeightTracking() {
            const targets = this.getHeaderMeasureTargets();
            if (!targets.length) return;

            if (!this._headerObserver) {
                this._headerObserver = new ResizeObserver(() => this._boundHeaderHeight());
            }

            targets.forEach((el) => this._headerObserver.observe(el));
            this.updateHeaderHeightVar();
        }

        setBodyCssVar(name, value) {
            const next = value || '';
            if (document.body.style.getPropertyValue(name) === next) return false;
            if (!next) document.body.style.removeProperty(name);
            else document.body.style.setProperty(name, next);
            return true;
        }

        updateSidebarHeightVar() {
            const sidebar = this.querySelector('[data-bundle-sidebar]');
            if (!sidebar) {
                this.clearSidebarHeightVar();
                return;
            }

            const height = Math.ceil(sidebar.getBoundingClientRect().height);
            this.setBodyCssVar(SIDEBAR_HEIGHT_VAR, height ? `${height}px` : '');
            this.handleViewportState();
        }

        updateHeaderHeightVar() {
            const height = this.getHeaderOffsetHeight();
            if (!height) {
                this.clearHeaderHeightVar();
                return;
            }

            this.setBodyCssVar(HEADER_HEIGHT_VAR, `${height}px`);
            this.handleViewportState();
        }

        handleViewportState() {
            this.updateSidebarStickyState();
        }

        updateSidebarStickyState() {
            const sidebar = this.querySelector('[data-bundle-sidebar]');
            if (!sidebar) return;

            const style = window.getComputedStyle(sidebar);
            if (style.position !== 'sticky') {
                sidebar.classList.remove('is-scrolling');
                return;
            }

            const rect = sidebar.getBoundingClientRect();
            const top = Number.parseFloat(style.top);
            const bottom = Number.parseFloat(style.bottom);
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            const epsilon = 1;

            const isTopSticky = Number.isFinite(top) && Math.abs(rect.top - top) <= epsilon;
            const isBottomSticky =
                Number.isFinite(bottom) && Math.abs(rect.bottom - (viewportHeight - bottom)) <= epsilon;

            sidebar.classList.toggle('is-scrolling', isTopSticky || isBottomSticky);
        }

        clearSidebarHeightVar() {
            this.setBodyCssVar(SIDEBAR_HEIGHT_VAR, '');
        }

        clearHeaderHeightVar() {
            this.setBodyCssVar(HEADER_HEIGHT_VAR, '');
        }

        renderAddButton() {
            const wrap = this.querySelector('[data-bundle-add-wrap]');
            if (!wrap) return;

            const filled = this.getFilledSlotCount();
            const canAdd =
                !this.isBundleFull() &&
                !!this.selectedProductId &&
                !!this.selectedSize &&
                filled < 2;

            wrap.classList.toggle('is-disabled', !canAdd);
            wrap.innerHTML = `
        <button type="button" class="btn ${tn}-bundle-products__add-btn" data-action="add-jersey" ${!canAdd ? 'disabled' : ''}>
          <span class="btn__text">${escapeHtml(this.copy.addJersey)}</span>
        </button>
      `;

        }

        resolveVariant(product, size) {
            const optionIndex = this.getSizeOptionIndex(product);
            if (optionIndex < 0) return product.variants?.find((v) => v.available) || product.variants?.[0];
            const optionKey = `option${optionIndex + 1}`;
            const target = normalizeSize(size);
            return (
                (product.variants || []).find((v) => normalizeSize(v[optionKey]) === target && v.available) ||
                (product.variants || []).find((v) => normalizeSize(v[optionKey]) === target)
            );
        }

        addJersey() {
            if (!this.selectedProductId || !this.selectedSize || !this.selectedProductData) return;
            if (!this.isBundleEligibleProduct(this.selectedProductData)) return;
            if (this.slots.filter(Boolean).length >= 2) return;

            const variant = this.resolveVariant(this.selectedProductData, this.selectedSize);
            if (!variant) return;

            const slotIndex = this.slots.findIndex((s) => !s);
            if (slotIndex === -1) return;

            const image = this.getProductImage(this.selectedProductData);
            this.slots[slotIndex] = {
                productId: this.selectedProductData.id,
                handle: this.selectedProductData.handle,
                title: this.selectedProductData.title,
                cutline: this.getCutline(this.selectedProductData),
                image,
                size: this.selectedSize,
                variantId: variant.id,
                price: this.getVariantPriceCents(variant),
            };

            this.syncStepFromSlots();

            this.selectedProductId = null;
            this.selectedSize = null;
            this.selectedProductData = null;
            this.saveToSessionStorage();
            this.renderAll();
        }

        removeJersey(slotIndex) {
            if (slotIndex < 0 || slotIndex > 1) return;
            this.slots[slotIndex] = null;

            if (slotIndex === 0 && this.slots[1]) {
                this.slots[0] = this.slots[1];
                this.slots[1] = null;
            }

            this.syncStepFromSlots();

            this.selectedProductId = null;
            this.selectedSize = null;
            this.selectedProductData = null;
            this.saveToSessionStorage();
            this.renderAll();
        }

        calculatePricing() {
            const filled = this.slots.filter(Boolean);
            if (filled.length < 2) {
                return { subtotal: null, discount: null, total: null };
            }
            const subtotal = filled.reduce((sum, item) => sum + Number(item.price || 0), 0);
            const discount = this.getBundleDiscountCents(subtotal);
            return { subtotal, discount, total: subtotal - discount };
        }

        buildCtaButtonHtml(cta) {
            return `<button type="button" class="btn ${tn}-bundle-products__cta-btn${cta.disabled ? ' is-disabled' : ''}" data-action="sidebar-cta" ${cta.disabled ? 'disabled' : ''}>
            <span class="btn__text">${escapeHtml(cta.label)}</span>
            ${cta.action === 'checkout' ? CTA_CHECKOUT_ICON_SVG : ''}
          </button>`;
        }

        getSidebarCta() {
            const filled = this.slots.filter(Boolean).length;

            if (filled >= 2) {
                return {
                    label: this.copy.continueCheckout,
                    disabled: false,
                    action: 'checkout',
                };
            }

            return {
                label: filled === 1 ? this.copy.selectJersey1 : this.copy.selectJersey2,
                disabled: true,
                action: 'advance',
            };
        }

        setCheckoutCtaLoading(isLoading) {
            this.querySelectorAll('[data-action="sidebar-cta"]').forEach((btn) => {
                btn.classList.toggle(`${tn}-bundle-products__cta-btn--loading`, isLoading);
                if (isLoading) {
                    btn.disabled = true;
                    return;
                }
                const cta = this.getSidebarCta();
                btn.disabled = !!cta.disabled;
                btn.classList.toggle('is-disabled', !!cta.disabled);
            });
        }

        handleSidebarCta() {
            const filled = this.slots.filter(Boolean).length;
            if (filled === 1) {
                this.syncStepFromSlots();
                this.renderAll();
                this.querySelector(`.${tn}-bundle-products__main`)?.scrollIntoView({ behavior: 'smooth' });
                return;
            }
            if (filled >= 2) {
                this.checkout();
            }
        }

        renderSlotHtml(slot, index) {
            const c = this.copy;
            const isActive =
                (index === 0 && this.step === 1 && !slot) ||
                (index === 1 && this.step === 2 && !slot) ||
                (index === this.activeSlotIndex && !slot);

            if (!slot) {
                const isSelecting = isActive || (index === 0 && !this.slots[0]) || (index === 1 && this.slots[0] && !this.slots[1]);
                return `
          <div class="${tn}-bundle-products__slot${isSelecting ? ' is-active' : ' is-empty'}">
            <div class="${tn}-bundle-products__slot-image ${tn}-bundle-products__slot-image--placeholder">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M16.364 3.63604C17.8792 5.15132 18.8041 7.15755 18.9723 9.29387C19.1404 11.4302 18.5407 13.5564 17.2812 15.2901C16.0216 17.0237 14.1847 18.2511 12.101 18.7513C10.0173 19.2516 7.82344 18.9919 5.91408 18.0191C4.00472 17.0462 2.50514 15.424 1.68508 13.4441C0.86502 11.4643 0.778291 9.25689 1.44049 7.21884C2.1027 5.1808 3.47037 3.44591 5.29752 2.32624C7.12467 1.20656 9.29137 0.775577 11.4079 1.11081" stroke="#646464" stroke-width="2" stroke-linecap="round"/>
</svg>
            </div>
            <div class="${tn}-bundle-products__slot-body">
              <span class="${tn}-bundle-products__slot-label">${escapeHtml((index === 0 ? c.jersey1 : c.jersey2).toUpperCase())}</span>
              <strong class="${tn}-bundle-products__slot-status">${escapeHtml(isSelecting ? c.selecting : c.notSelected)}</strong>
              <p class="${tn}-bundle-products__slot-hint">${escapeHtml(index === 0 ? c.pickFirst : c.completeDuo)}</p>
            </div>
          </div>
        `;
            }

            return `
        <div class="${tn}-bundle-products__slot is-filled">
          <div class="${tn}-bundle-products__slot-image">
            <img src="${escapeHtml(slot.image)}" alt="${escapeHtml(slot.title)}" width="80" height="120" loading="lazy" />
          </div>
          <div class="${tn}-bundle-products__slot-body">
            <span class="${tn}-bundle-products__slot-label">${escapeHtml((index === 0 ? c.jersey1 : c.jersey2).toUpperCase())}</span>
            <strong class="${tn}-bundle-products__slot-title">${escapeHtml(slot.title)}</strong>
            <p class="${tn}-bundle-products__slot-size">${escapeHtml(c.sizePrefix)} ${escapeHtml(slot.size)}</p>
          </div>
          <button type="button" class="${tn}-bundle-products__slot-remove" data-action="remove-jersey" data-slot-index="${index}" aria-label="Remove jersey">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z" fill="#646464"/>
</svg>
          </button>
        </div>
      `;
        }

        renderSidebar() {
            const sidebar = this.querySelector('[data-bundle-sidebar]');
            if (!sidebar) return;

            const c = this.copy;
            const pricing = this.calculatePricing();
            const cta = this.getSidebarCta();
            const filled = this.slots.filter(Boolean).length;

            sidebar.innerHTML = `
        ${this.renderSlotHtml(this.slots[0], 0)}
        ${this.renderSlotHtml(this.slots[1], 1)}
        <div class="${tn}-bundle-products__summary">
          <div class="${tn}-bundle-products__summary-row">
            <span>${escapeHtml(c.twoJerseys)}</span>
            <span>${pricing.subtotal != null ? this.formatMoney(pricing.subtotal) : '...'}</span>
          </div>
          <div class="${tn}-bundle-products__summary-row ${tn}-bundle-products__summary-row--discount">
            <span>${escapeHtml(c.bundleDiscount)}</span>
            <span>${pricing.discount != null ? `- ${this.formatMoney(pricing.discount)}` : '...'}</span>
          </div>
          <div class="${tn}-bundle-products__summary-total">
            <span>${escapeHtml(c.total)}</span>
            <strong>${pricing.total != null ? this.formatMoney(pricing.total) : '...'}</strong>
          </div>
        </div>
        <div class="${tn}-bundle-products__sidebar-cta">
          ${this.buildCtaButtonHtml(cta)}
          <p class="${tn}-bundle-products__shipping-note">
           <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M2.58411 12.2167C2.19523 11.8278 2.00078 11.3556 2.00078 10.8H0.800781V4.00005C0.800781 3.67005 0.918281 3.38755 1.15328 3.15255C1.38828 2.91755 1.67078 2.80005 2.00078 2.80005H11.2008V5.20005H13.2008L15.2008 8.00005V10.8H14.0008C14.0008 11.3556 13.8063 11.8278 13.4174 12.2167C13.0286 12.6056 12.5563 12.8 12.0008 12.8C11.4452 12.8 10.973 12.6056 10.5841 12.2167C10.1952 11.8278 10.0008 11.3556 10.0008 10.8H6.00078C6.00078 11.3556 5.80634 11.8278 5.41745 12.2167C5.02856 12.6056 4.55634 12.8 4.00078 12.8C3.44523 12.8 2.973 12.6056 2.58411 12.2167ZM4.56745 11.3667C4.723 11.2112 4.80078 11.0223 4.80078 10.8C4.80078 10.5778 4.723 10.3889 4.56745 10.2334C4.41189 10.0778 4.223 10 4.00078 10C3.77856 10 3.58967 10.0778 3.43411 10.2334C3.27856 10.3889 3.20078 10.5778 3.20078 10.8C3.20078 11.0223 3.27856 11.2112 3.43411 11.3667C3.58967 11.5223 3.77856 11.6 4.00078 11.6C4.223 11.6 4.41189 11.5223 4.56745 11.3667ZM2.00078 9.60005H2.40078C2.58967 9.34449 2.823 9.14727 3.10078 9.00838C3.37856 8.86949 3.67856 8.80005 4.00078 8.80005C4.323 8.80005 4.623 8.86949 4.90078 9.00838C5.17856 9.14727 5.40928 9.34449 5.59295 9.60005H10.0008V4.00005H2.00078V9.60005ZM12.5674 11.3667C12.723 11.2112 12.8008 11.0223 12.8008 10.8C12.8008 10.5778 12.723 10.3889 12.5674 10.2334C12.4119 10.0778 12.223 10 12.0008 10C11.7786 10 11.5897 10.0778 11.4341 10.2334C11.2786 10.3889 11.2008 10.5778 11.2008 10.8C11.2008 11.0223 11.2786 11.2112 11.4341 11.3667C11.5897 11.5223 11.7786 11.6 12.0008 11.6C12.223 11.6 12.4119 11.5223 12.5674 11.3667ZM11.2008 8.40005L14.0008 8.38338L12.5841 6.40005H11.2008V8.40005Z" fill="#646464"/>
</svg>
            ${escapeHtml(this.copy.freeShipping)}
          </p>
        </div>
      `;

            sidebar.classList.toggle('is-complete', filled >= 2);
            this.updateSidebarHeightVar();
        }

        renderMobileCta() {
            const mobile = this.querySelector('[data-bundle-mobile-cta]');
            if (!mobile) return;
            const cta = this.getSidebarCta();
            mobile.innerHTML = this.buildCtaButtonHtml(cta);
        }

        async checkout() {
            const items = this.slots.filter(Boolean);
            if (items.length < 2) return;
            if (items.some((item) => !item.variantId || !item.size)) return;

            this.setCheckoutCtaLoading(true);

            try {
                const res = await fetch(`${this.rootPath}cart/add.js`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        items: items.map((item) => ({ id: item.variantId, quantity: 1 })),
                    }),
                });
                if (!res.ok) throw new Error('Cart add failed');
                document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
                this.clearSessionStorage();
                const code = this.config.discountCode || '';
                const url = code ? `${this.rootPath}checkout?discount=${encodeURIComponent(code)}` : `${this.rootPath}checkout`;
                window.location.href = url;
            } catch (err) {
                console.error(`[${tn}-bundle-products] checkout`, err);
                this.setCheckoutCtaLoading(false);
            }
        }

        normalizeKiwiImageUrl(url) {
            if (!url) return '';
            return url.startsWith('//') ? `https:${url}` : url;
        }

        getKiwiImages(product) {
            const images = (product.images || [])
                .map((img) => this.normalizeKiwiImageUrl(typeof img === 'string' ? img : img?.src))
                .filter(Boolean);
            const featured = this.normalizeKiwiImageUrl(product.featured_image);
            return images.length ? images : featured ? [featured] : [];
        }

        buildSizeChartPlaceholderHtml(label) {
            return `<button type="button" class="${tn}-bundle-products__size-chart-placeholder" data-bundle-size-chart-placeholder data-action="open-size-chart">
        ${SIZE_CHART_ICON_SVG}
        <span>${escapeHtml(label || 'Size Chart')}</span>
      </button>`;
        }

        nextKiwiHostId() {
            this._kiwiHostSeq += 1;
            return `KiwiSizingChart-${Date.now()}-${this._kiwiHostSeq}`;
        }

        buildKiwiHostHtml() {
            return `<div id="${this._kiwiHostId}" class="kiwisizingchart" data-bundle-kiwi-host data-display-mode="1" data-recommender-display-mode="1" data-layout-type="0"></div>`;
        }

        getKiwiChartWrap() {
            return this.querySelector('[data-bundle-size-chart-host]');
        }

        getKiwiChartHost(wrap = this.getKiwiChartWrap()) {
            return wrap?.querySelector('[data-bundle-kiwi-host]') || wrap?.querySelector(`#${this._kiwiHostId}`) || null;
        }

        getKiwiTrigger(wrap = this.getKiwiChartWrap()) {
            return wrap?.querySelector(KIWI_TRIGGER_SELECTOR) || null;
        }

        hasKiwiChart(wrap = this.getKiwiChartWrap()) {
            return !!this.getKiwiTrigger(wrap);
        }

        getKiwiHostProductId(wrap = this.getKiwiChartWrap()) {
            return this.getKiwiChartHost(wrap)?.getAttribute('data-product') || '';
        }

        replaceKiwiChartHost() {
            const wrap = this.getKiwiChartWrap();
            if (!wrap) return null;

            const currentHost = this.getKiwiChartHost(wrap);
            this._kiwiHostId = this.nextKiwiHostId();
            const hostHtml = this.buildKiwiHostHtml();

            if (currentHost) {
                currentHost.insertAdjacentHTML('afterend', hostHtml);
                currentHost.remove();
            } else {
                wrap.insertAdjacentHTML('beforeend', hostHtml);
            }

            return this.getKiwiChartHost(wrap);
        }

        kiwiDomMatchesProduct(wrap, productId) {
            if (!wrap || !productId) return false;
            return String(this.getKiwiHostProductId(wrap)) === String(productId) && this.hasKiwiChart(wrap);
        }

        clearStaleKiwiChart(productId) {
            const wrap = this.getKiwiChartWrap();
            if (!wrap || !this.hasKiwiChart(wrap)) return;
            if (!productId || !this.kiwiDomMatchesProduct(wrap, productId)) {
                this.clearKiwiDom();
            }
        }

        ensureSizeChartPlaceholder() {
            const wrap = this.getKiwiChartWrap();
            if (!wrap || wrap.querySelector('[data-bundle-size-chart-placeholder]')) return;
            wrap.insertAdjacentHTML('afterbegin', this.buildSizeChartPlaceholderHtml(this.copy.sizeChart));
        }

        renderSizeChart(productId) {
            const wrap = this.getKiwiChartWrap();
            if (!wrap) return;

            const syncKey = productId ? String(productId) : '';
            const cached = syncKey ? this._kiwiChartCache.get(syncKey) : undefined;
            const domMatches = this.kiwiDomMatchesProduct(wrap, productId);
            const kiwiReady = !!syncKey && cached === true && domMatches;
            const loading =
                !!syncKey &&
                !kiwiReady &&
                this._kiwiLoadingProductId === productId &&
                cached !== false;

            wrap.classList.toggle('is-kiwi-active', kiwiReady);
            wrap.classList.toggle('is-kiwi-loading', loading);

            if (kiwiReady || loading) {
                wrap.querySelector('[data-bundle-size-chart-placeholder]')?.remove();
            } else {
                this.ensureSizeChartPlaceholder();
            }
        }

        initKiwiModalTracking() {
            const root = document.documentElement;
            if (!root || this._kiwiModalObserver) return;

            this._kiwiModalWasOpen = root.classList.contains('kiwi-sizing-modal-visible');
            this._kiwiModalObserver = new MutationObserver(() => {
                const isOpen = root.classList.contains('kiwi-sizing-modal-visible');
                if (this._kiwiModalWasOpen && !isOpen) {
                    this.restoreScrollAfterKiwiClose();
                }
                this._kiwiModalWasOpen = isOpen;
            });

            this._kiwiModalObserver.observe(root, { attributes: true, attributeFilter: ['class'] });
        }

        rememberKiwiReturnProduct() {
            this._kiwiScrollReturnProductId = this.selectedProductId || null;
        }

        restoreScrollAfterKiwiClose() {
            const selectedSelector = `.${tn}-bundle-products__card--selected`;
            const fallbackSelector = this._kiwiScrollReturnProductId
                ? `[data-product-id="${this._kiwiScrollReturnProductId}"]`
                : '';
            const target =
                this.querySelector(selectedSelector) ||
                (fallbackSelector ? this.querySelector(fallbackSelector) : null);
            if (!target) return;

            const scrollToTarget = () => {
                const rect = target.getBoundingClientRect();
                const currentY = window.scrollY || window.pageYOffset || 0;
                const viewportCenter = (window.innerHeight || 0) / 2;
                const targetCenter = rect.top + currentY + rect.height / 2;
                const top = Math.max(0, Math.round(targetCenter - viewportCenter));
                window.scrollTo({ top, left: 0, behavior: 'auto' });
            };

            requestAnimationFrame(() => {
                scrollToTarget();
                setTimeout(scrollToTarget, 80);
            });
        }

        openSizeChart() {
            const wrap = this.getKiwiChartWrap();
            const productId = this.selectedProductId;
            if (
                !wrap ||
                !productId ||
                !wrap.classList.contains('is-kiwi-active') ||
                !this.kiwiDomMatchesProduct(wrap, productId) ||
                this.querySelector('[data-bundle-size-dock]')?.classList.contains('is-disabled')
            ) {
                return;
            }

            this.rememberKiwiReturnProduct();
            this.getKiwiTrigger(wrap)?.click();
        }

        clearKiwiDom() {
            const wrap = this.getKiwiChartWrap();
            if (!wrap) return;

            wrap.querySelectorAll('.ks-chart-container, .ks-calculator-container, .ks-chart-modal-link').forEach((el) => el.remove());

            const host = this.getKiwiChartHost();
            if (!host) return;

            host.innerHTML = '';
            [
                'data-product',
                'data-product-name',
                'data-vendor',
                'data-type',
                'data-tags',
                'data-product-images',
                'data-collections',
            ].forEach((attr) => host.removeAttribute(attr));
        }

        resetKiwiHost() {
            this.clearKiwiDom();
            this.ensureSizeChartPlaceholder();
        }

        dedupeKiwiInjections() {
            const wrap = this.getKiwiChartWrap();
            if (!wrap) return;

            ['.ks-chart-container', '.ks-calculator-container', '.ks-chart-modal-link'].forEach((selector) => {
                const nodes = wrap.querySelectorAll(selector);
                for (let i = 0; i < nodes.length - 1; i += 1) {
                    nodes[i].remove();
                }
            });
        }

        buildKiwiProductData(product) {
            const tags = Array.isArray(product.tags) ? product.tags : [];
            const collectionValues = (product.collections || [])
                .map((c) => {
                    if (typeof c === 'string' || typeof c === 'number') return String(c);
                    if (c?.id) return String(c.id);
                    return c?.handle || '';
                })
                .filter(Boolean);
            const handleValues = Array.isArray(product._collectionHandles) ? product._collectionHandles : [];
            const categories = [...new Set([...collectionValues, ...handleValues])];
            const images = this.getKiwiImages(product);

            return {
                productID: String(product.id),
                product: String(product.id),
                title: product.title || '',
                images,
                tags: tags.join(','),
                brand: product.vendor || '',
                vendor: product.vendor || '',
                type: product.type || product.product_type || '',
                collections: categories.join(','),
                categories,
            };
        }

        setKiwiHostAttributes(product) {
            const host = this.getKiwiChartHost();
            const data = this.buildKiwiProductData(product);
            if (!host || !data) return;

            host.setAttribute('data-product', String(data.productID || data.product));
            host.setAttribute('data-product-name', data.title || '');
            host.setAttribute('data-vendor', data.vendor || '');
            host.setAttribute('data-type', data.type || '');
            host.setAttribute('data-tags', data.tags || '');
            host.setAttribute('data-product-images', JSON.stringify(data.images || []));
            host.setAttribute('data-collections', data.collections || '');
        }

        configureKiwiShop() {
            const shopId = window.KiwiSizing?.shopId || window.KiwiSizing?.shopID || window.KiwiSizing?.shop_id;
            if (shopId && typeof window.ks?.setShopID === 'function') {
                window.ks.setShopID(String(shopId));
            }
        }

        waitForKiwi(timeout = 8000) {
            return new Promise((resolve) => {
                const started = Date.now();
                const check = () => {
                    if (typeof window.ks?.loadSizing === 'function') {
                        this.configureKiwiShop();
                        resolve(true);
                        return;
                    }
                    if (Date.now() - started >= timeout) {
                        resolve(false);
                        return;
                    }
                    setTimeout(check, 100);
                };
                check();
            });
        }

        scheduleKiwiSync(product) {
            clearTimeout(this._kiwiSyncTimer);

            const syncProductId = product?.id || null;
            const syncKey = syncProductId ? String(syncProductId) : '';
            const cached = syncKey ? this._kiwiChartCache.get(syncKey) : undefined;

            if (this._kiwiSyncProductId !== syncProductId) {
                this._kiwiSyncProductId = syncProductId;
                this._kiwiLoadId += 1;
            }

            this._kiwiLoadingProductId =
                syncProductId && cached !== false && !this.kiwiDomMatchesProduct(this.getKiwiChartWrap(), syncProductId)
                    ? syncProductId
                    : null;

            this.clearStaleKiwiChart(syncProductId);
            this.renderSizeChart(syncProductId);

            this._kiwiSyncTimer = setTimeout(async () => {
                if (this._kiwiSyncProductId !== syncProductId) return;

                if (!syncProductId) {
                    this._kiwiLoadingProductId = null;
                    this.resetKiwiHost();
                    this.renderSizeChart(null);
                    return;
                }

                if (!(await this.waitForKiwi())) {
                    this._kiwiLoadingProductId = null;
                    this.renderSizeChart(syncProductId);
                    return;
                }

                if (this._kiwiSyncProductId !== syncProductId) return;

                let productData = product;
                if (productData?.handle) {
                    productData = (await this.resolveProductDetails(productData.handle)) || productData;
                }

                if (this._kiwiSyncProductId !== syncProductId) return;

                this.loadKiwiChart(productData);
            }, 0);
        }

        pollKiwiReady({ wrap, loadId, productId, syncKey, attempt = 0 }) {
            if (loadId !== this._kiwiLoadId || String(this.selectedProductId) !== String(productId)) {
                this._kiwiLoadingProductId = null;
                return;
            }

            this.dedupeKiwiInjections();

            if (this.kiwiDomMatchesProduct(wrap, productId)) {
                this._kiwiLoadingProductId = null;
                this.renderSizeChart(productId);
                return;
            }

            if (attempt >= 30) {
                this._kiwiChartCache.set(syncKey, false);
                this._kiwiLoadingProductId = null;
                this.resetKiwiHost();
                this.renderSizeChart(productId);
                return;
            }

            setTimeout(() => this.pollKiwiReady({ wrap, loadId, productId, syncKey, attempt: attempt + 1 }), 100);
        }

        onKiwiLoaded(success, { wrap, loadId, productId, syncKey }) {
            if (loadId !== this._kiwiLoadId || String(this.selectedProductId) !== String(productId)) return;

            if (!success) {
                this._kiwiChartCache.set(syncKey, false);
                this._kiwiLoadingProductId = null;
                this.resetKiwiHost();
                this.renderSizeChart(productId);
                return;
            }

            this._kiwiChartCache.set(syncKey, true);
            this.pollKiwiReady({ wrap, loadId, productId, syncKey });
        }

        loadKiwiChart(product) {
            const wrap = this.getKiwiChartWrap();
            if (!wrap || !product?.id || typeof window.ks?.loadSizing !== 'function') return;

            let host = this.getKiwiChartHost(wrap) || this.replaceKiwiChartHost();
            if (!host) return;

            const syncKey = String(product.id);

            if (this._kiwiChartCache.get(syncKey) === false) {
                this._kiwiLoadingProductId = null;
                this.resetKiwiHost();
                this.renderSizeChart(product.id);
                return;
            }

            if (this._kiwiChartCache.get(syncKey) === true && this.kiwiDomMatchesProduct(wrap, product.id)) {
                this._kiwiLoadingProductId = null;
                this.renderSizeChart(product.id);
                return;
            }

            this._kiwiLoadingProductId = product.id;
            if (String(this.getKiwiHostProductId(wrap)) !== String(product.id)) {
                host = this.replaceKiwiChartHost() || host;
            }
            this.clearKiwiDom();
            host = this.getKiwiChartHost(wrap) || host;
            this.setKiwiHostAttributes(product);
            this.renderSizeChart(product.id);

            const kiwiData = this.buildKiwiProductData(product);
            if (!kiwiData) {
                this._kiwiLoadingProductId = null;
                this.renderSizeChart(product.id);
                return;
            }

            const loadId = ++this._kiwiLoadId;

            window.ks.loadSizing({
                productData: {
                    ...(window.KiwiSizing?.data || {}),
                    ...kiwiData,
                },
                options: {
                    el: host,
                    displayMode: 1,
                    recommenderDisplayMode: 1,
                    layoutType: 0,
                },
                loaded: (success) => this.onKiwiLoaded(success, { wrap, loadId, productId: product.id, syncKey }),
            });
        }
    }

    if (!customElements.get('xlr8d-cf-product-21')) {
        customElements.define('xlr8d-cf-product-21', Xlr8dCfProduct21);
    }
})();
